import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import "./App.css";
import * as Constants from "./utils/Constants";
import * as UtilMethods from "./utils/UtilMethods";
import { sortAllSortBoxItemsByExistingSortboxItems} from "./lib/aframeboxlookup/UtilMethods";
import AFrameConstants from "./lib/aframeboxlookup/Constants";
import BoxReviewConstans from  "./lib/boxReview/Constants";
import BoxItemList from "./components/BoxItemList/BoxItemList";
import SingleItemList from "./components/SingleItemList/SingleItemList";
import WarningModal from "./components/WarningModal/WarningModal";
import Login from "./components/Login/Login";
import InfoFooter from "./components/InfoFooter/InfoFooter";
import ErrorAlert from "./components/ErrorAlert/ErrorAlert";
import SharedFunctions from "./utils/SharedFunctions";
import MissingSkuModal from "./components/MissingSkuModal/MissingSkuModal";
import { StatePersistor } from "./utils/StatePersistor";
import { Icon, Dimmer, Loader, Grid, Button } from "semantic-ui-react";
import IPackBoxStatus from "./components/IPackBoxStatus/IPackBoxStatus";
import SideBarMenu from "./components/SideBarMenu/SideBarMenu";
import DevDashBoard from "./components/DevDashBoard/DevDashBoard";
import NumPad from "./components/NumPad/NumPad";
import WarningList from "./components/AFrameControlStation/WarningList/WarningList";
import ShopLogo from "./components/ShopLogo/ShopLogo";
import BoxErrorModal from "./components/BoxErrorModal/BoxErrorModal";
import FailureToDeliverModal from "./components/FailureToDeliverModal/FailureToDeliverModal";
import { SignalR } from "./utils/SignalRUtil";
import ArticleWeightModal from "./components/ArticleWeightModal/ArticleWeightModal";
import OperatorInputModal from "./components/OperatorInputModal/OperatorInputModal";
import FinalizeSortModal from "./components/FinalizeSortModal/FinalizeSortModal";
import ScanShippingLabelModal from "./components/ScanShippingLabelModal/ScanShippingLabelModal";
import ScanShippingContainerModal from "./components/ScanShippingContainerModal/ScanShippingContainerModal";
import PartialDeliveryConfirmationModal from "./components/PartialDeliveryConfirmationModal/PartialDeliveryConfirmationModal";
import AFrameConfirmationModal from "./components/AFrameControlStation/ConfirmationModal/ConfirmationModal";
import FinalizeEmptyAFrameMixedModal from "./components/FinalizeEmptyAFrameMixedModal/FinalizeEmptyAFrameMixedModal";
import CartContent from "./components/CartContent/CartContent";
import InfoBar from "./components/InfoBar/InfoBar";
import OperatorConfirmModal from "./components/OperatorConfirmModal/OperatorConfirmModal";
import BoxLookupConstants from "./lib/boxlookup/Constants";
import SortBox from "./lib/SortBox";
import TwoDScan from "./lib/2DScan";
import CollectingAverage from "./components/CollectingAverage/CollectingAverage";
import * as sortBoxLockExpirationUtil from "./utils/SortBoxLockExpirationUtil";
import * as operatorInstructionUtil from "./utils/OperatorInstructionUtil";
import HomeEndpoints from "./lib/home/HomeEndpoints";
import IPackEndpoints from "./lib/ipack/IPackEndpoints";
import OperatorEndpoints from "./lib/operator/OperatorEndpoints";
import SettingsEndpoints from "./lib/settings/SettingsEndpoints";
import SinglesEndpoints from "./lib/singles/SinglesEndpoints";
import WorkstationEndpoints from "./lib/workstation/WorkstationEndpoints";
import SkuEndpoints from "./lib/sku/SkuEndpoints";
import SortBoxEndpoints from "./lib/sortbox/SortBoxEndpoints";
import CartEndpoints from "./lib/cart/CartEndpoints";
import BoxLookupEndpoints from "./lib/boxlookup/BoxLookupEndpoints";
import { checkVersion } from "./utils/versionCheck/versionCheck";
import { WARNING_MODAL } from "./utils/constants/componentConstants";
import {
  FINALIZE_SORTBOX_ERROR_CODE,
  PERFORM_NEXT_ACTION_SET_CART_ERROR_CODE,
  PERFORM_NEXT_ACTION_SEARCH_BOX_ERROR_CODE,
  PERFORM_NEXT_ACTION_DEFAULT_ERROR_CODE,
  SHOW_WORKSTATION_INSTRUCTION_ERROR_CODE,
  SHOW_WORKSTATION_NO_INSTRUCTION_ERROR_CODE,
  GET_SKU_ID_FROM_INPUT_ERROR_CODE,
  SCAN_INPUT_TYPE_2D_ERROR_CODE,
  SEND_EVERIFICATION_SCAN_ERROR_CODE,
  ON_ERROR_FINALIZE_SORTBOX_ERROR_CODE,
  CANCEL_SORTBOX_ERROR_CODE,
  FAILURE_TO_DELIVER_CANCEL_SORTBOX_ERROR_CODE,
  OPERATOR_CONFIRM_MODAL_ERROR_CODE,
  VALIDATE_FINALIZE_STATE_ERROR_CODE,
  REPARK_CART_INSTRUCTION,
} from "./utils/constants/errorCodes";

/*
 * REDUX ACTION IMPORTS
 */
import {
  setCartSuggestion,
  setCartID,
  clearCartState,
  scanCartID,
  setForceCart,
  setCompanyID,
  fetchCartData,
  setSortID,
  setRXEnabled,
  setCartType,
} from "./lib/store/reducers/cartReducer";

import {
  setLoadingStatus,
  setShouldRedirect,
  setShowLoader,
  setError,
  setWasCancelled,
  setLoginStatus,
  setPersistedSortID,
  setPersistedCartID,
  setAppMode,
  setIsBetaWorkstation,
  setBurnOrdersMustBeBackedFirst,
  setConveyorID,
  setPackingAllowed,
} from "./lib/store/reducers/applicationStateReducer";

import { setUser, setWorkstation } from "./lib/store/reducers/loginInfoReducer";
import {
  setCurrentInstruction,
  toggleShowInstruction,
  clearInstructions,
} from "./lib/store/reducers/instructionStateReducer";
import { PayloadWrapper } from "./lib/store/types/PayloadWrapper";
import { WorkstationInfoModel } from "./lib/interfaces/Login/IWorkstationInfoModel";
import { OperatorInfoModel } from "./lib/interfaces/Login/IOperatorInfoModel";
import { ApplicationMode } from "./lib/store/types/ApplicationStateTypes";
import {
  setAFrameAction,
  toggleverifyIPackBoxBarcodeModal,setAframeReviewWarning
} from "./lib/store/reducers/aframeModeReducer";
import {setMissingBoxItem} from "./lib/store/reducers/aFrameReviewBoxReducer"
import { clearBoxReviewState, reloadBoxReview, setBoxReviewAction, setBoxReviewModelItems } from "./lib/store/reducers/boxReviewReducer";
import { clearReviewBoxData, setOrderChecked, setAllSortboxItems, setAframeSortboxItems } from "./lib/store/reducers/aFrameReviewBoxReducer";
import { isAFrameMixed } from "./utils/sortTypeUtil";
import ISwitchAppModeProperty from "./components/SideBarMenu/SideBarMenuSettings";
import ClientEventEndpoints from "./lib/ClientEvent/ClientEventEndpoints";

const { ActionTypes, SortType, ClientMessageType, KeyPadKeyCode } = Constants;
const { ActionStates } = AFrameConstants;
const BoxReviewActionStates = BoxReviewConstans.ActionStates;

const cartState = {
  boxItems: [],
  singleItems: [],
  isCartInstruction: false,
  currentOrderNumber: -1,
  currentShelfNumber: -1,
  currentInvoiceNumber: -1,
  currentSortBoxID: -1,
  lastScannedSKU: -1,
  orderShopID: -1,
  sortBoxCompanyID: -1,
  nextAction: ActionTypes.SET_CART,
  scanIDs: [],
  packingPrioDeadlineId: -1,
  cartContent: null,
  isUrgent: false,
  isPaused: false,
  notFound: false,
  sortWorkstationType: 0,
  iPackBoxBarcode: null,
  iPackBoxID: -1,
  isPartialDelivery: false,
  partialDeliveryContinued: false,
  partialDeliveryStarted: false,
  verifyPartialDelivery: false,
  partialDeliveryAllowed: false,
  packageNumber: null,
};


const persistedStateConfig = {
  template: {
    ...cartState,
    operatorID: -1,
    removeSkuAccess: false,
    cancelSortBoxAccess: false,
    waitingForDeliveryRequest: false,
    waitingForEjectReport: false,
    waitingForNewIPackBox: true,
    warningMessage: "",
    warningHeader: "",
    warningClass: "",
    warningAutoClose: false,
    warningModalOpen: false,
    warningButtonText: null,
    warningErrorCode: null,
    warningOnCloseFunctionKey: null,
    showBoxErrorModal: false,
    failedToDeliver: false,
    failedToDeliverMessage: null,
    failedToDeliverErrorCode: null,
    boxErrorHeader: "",
    boxErrorMessage: "",
    finalizeSortModalOpen: false,
    packagingType: Constants.PackagingTypes.Neutral,
    pendingInstruction: "",
    verifyShippingLabelOpen: false,
    verifyShippingContainerOpen: false,
    logoutTime: null,
    showRxOrder: false,
    validateOrderInfo: null,
    partialDeliveryConfirmationModalOpen: false,
    lastInstruction: null,
    waitingforMeasurement: false,
    finalizeEmpty: false,
  },
  decidingKey: "operatorID",
  lifespanSeconds: 600,
  persistorPrefix: "-",
};
//not persisted state
const initialState = {
  missingBoxItem: "",
  showKeyboard: true,
};

const EJECT_ERROR_MESSAGE =
  "Lådan gick inte iväg. Kontrollera att det inte finns några paket under bordet.";
const EJECT_REMOVE_BOX_ERROR_MESSAGE =
  "Lådan gick inte iväg. Plocka bort lådan. Håll ner knapparna i 5 sekunder.";

class App extends Component {
  _gsCharInputFix;
  constructor() {
    super();
    this.updateLockExpirationTimeoutID = null;
    this.state = {
      ...initialState,
      ...StatePersistor.restoreState(
        persistedStateConfig.template,
        persistedStateConfig.lifespanSeconds,
        persistedStateConfig.decidingKey,
        persistedStateConfig.persistorPrefix
      ),
    };

    this.inputRef = React.createRef();
    this._setOperator = this._setOperator.bind(this);
    this._setWorkstationID = this._setWorkstationID.bind(this);
    this._skuIsMissing = this._skuIsMissing.bind(this);
    this._dismissMissingSku = this._dismissMissingSku.bind(this);
    this._performNextAction = this._performNextAction.bind(this);
    this._getNextSortBox = this._getNextSortBox.bind(this);
    this._getSkuIDFromInput = this._getSkuIDFromInput.bind(this);
    this._signOut = this._signOut.bind(this);
    this._pollForInactivity = this._pollForInactivity.bind(this);
    this._versionCheckPoll = this._versionCheckPoll.bind(this);
    this._updateSortBoxItems = this._updateSortBoxItems.bind(this);
    this._getNextSortBoxItem = this._getNextSortBoxItem.bind(this);
    this._addError = this._addError.bind(this);
    this._getMergedBoxItems = this._getMergedBoxItems.bind(this);
    this._forceNormalWorkstationShelf = this._forceNormalWorkstationShelf.bind(this);
    this._getIPackBoxIDAtWorkstation = this._getIPackBoxIDAtWorkstation.bind(this);
    this._logState = this._logState.bind(this);
    this._setBoxDeliveryCallback = this._setBoxDeliveryCallback.bind(this);
    this._startSignalR = this._startSignalR.bind(this);
    this._setStateWaitingForSingleArticleScan = this._setStateWaitingForSingleArticleScan.bind(
      this
    );
    this._setInputFocus = this._setInputFocus.bind(this);
    this._finalizeBox = this._finalizeBox.bind(this);
    this._cancelSortBox = this._cancelSortBox.bind(this);
    this._setWeightOnSku = this._setWeightOnSku.bind(this);
    this._updateBoxItemsState = this._updateBoxItemsState.bind(this);
    this._getWeightSku = this._getWeightSku.bind(this);
    this._setBoxErrorCallback = this._setBoxErrorCallback.bind(this);
    this._boxRemovedCallback = this._boxRemovedCallback.bind(this);
    this._gsCharInputFix = UtilMethods.GSCharInputFix.bind(this);
    this._setShowErrorCallback = this._setShowErrorCallback.bind(this);
    this._setBoxEjectCallback = this._setBoxEjectCallback.bind(this);
    this._setBoxResetCallback = this._setBoxResetCallback.bind(this);
    this._nextSortBoxTrigger = this._nextSortBoxTrigger.bind(this);
    this._waitForEjectReport = this._waitForEjectReport.bind(this);
    this._onErrorFinalizeSortbox = this._onErrorFinalizeSortbox.bind(this);
    this._failureToDeliverCallback = this._failureToDeliverCallback.bind(this);
    this._failureToDeliverAFrameMixedCallback = this._failureToDeliverAFrameMixedCallback.bind(
      this
    );
    this._onKeyPadClick = this._onKeyPadClick.bind(this);
    this._setBoxAtTableCallback = this._setBoxAtTableCallback.bind(this);
    this._changeCart = this._changeCart.bind(this);
    this._refreshSingleItemsGrid = this._refreshSingleItemsGrid.bind(this);
    this._handleSingelArticleScan = this._handleSingelArticleScan.bind(this);
    this._handleArticleScan = this._handleArticleScan.bind(this);
    this._pollForIPackBox = this._pollForIPackBox.bind(this);
    this._closeFinalizeSortModal = this._closeFinalizeSortModal.bind(this);
    this._completeValidateShippingLabelCallback = this._completeValidateShippingLabelCallback.bind(
      this
    );

    this._validateShippingContainterCallback = this._validateShippingContainterCallback.bind(this);
    this._checkForInstruction = this._checkForInstruction.bind(this);
    this._startSingelSort = this._startSingelSort.bind(this);
    this._performPartialDelivery = this._performPartialDelivery.bind(this);
    this._pollForInstruction = this._pollForInstruction.bind(this);
    this._cartState = cartState;
    this._measurementCallback = this._measurementCallback.bind(this);
    this._showWorkstationInstruction = this._showWorkstationInstruction.bind(this);
    this._instructParkLocation = this._instructParkLocation.bind(this);
    this._getWarningModalOnCloseFunctionByKey = this._getWarningModalOnCloseFunctionByKey.bind(
      this
    );
    this._setScannedBoxManually = this._setScannedBoxManually.bind(this);
  }

  async componentDidMount() {
    if (this.props.appState.appMode === ApplicationMode.BoxReviewMode) {
      this._handleBoxReviewMode();
    } else if (this.props.appState.appMode === ApplicationMode.AFrameReviewMode) {
      this._handleAFrameReviewMode();
    }

    await this._setWorkstationID().then(() => {
      if (this.props.appState.appMode !== ApplicationMode.AFrameReviewMode) {
        this._pollForInactivity();
      }

      this._versionCheckPoll();
      document.getElementById("root").addEventListener("click", (e) => {
        //vissa element vill man exkludera från skannerns autofocus
        //ex.förhindrar skanningar när man klickar på saknas för en vara
        var toExclude = [...document.querySelectorAll(".ArticleImageContainer button")];

        if (toExclude.indexOf(e.target) === -1) {
          this._setInputFocus();
        }
      });

      if (this.props.appState.appMode !== ApplicationMode.AFrameReviewMode) {
        setInterval(this._pollForIsPackingAllowed, 10000);
        setInterval(this._pollForInstruction, 10000);
      }

      if (UtilMethods.IsAutoPack(this.props.loginState.workstationType)) {
        this._setBoxDeliveryCallback();
        this._setBoxErrorCallback();
        this._setShowErrorCallback();
        this._setBoxEjectCallback();
        this._setBoxResetCallback();
        this._setBoxAtTableCallback();
        this._startSignalR();
        this._pollForIPackBox();
      } else if (UtilMethods.IsManualPack(this.props.loginState.workstationType)) {
        this.setState({
          waitingForNewIPackBox: false,
        });
      }
      this._gsCharInputFix();
      this._updateLockExpiration();
    });
  }

  componentWillUnmount() {
    clearInterval(this._versionCheckInterval);
    this._clearUpdateLockExpiration();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentSortBoxID === -1 && this.state.currentSortBoxID !== -1) {
      this._clearUpdateLockExpiration();
      this._updateLockExpiration();
    } else if (
      prevState.currentSortBoxID !== -1 &&
      this.state.currentSortBoxID !== -1 &&
      prevState.currentSortBoxID !== this.state.currentSortBoxID
    ) {
      this._clearUpdateLockExpiration();
      this._updateLockExpiration();
    }

    if (
      prevState.waitingForNewIPackBox !== this.state.waitingForNewIPackBox &&
      !this.state.waitingForNewIPackBox &&
      !this.state.waitingForDeliveryRequest &&
      this._hasBox() &&
      this._allItemsVerified()
    ) {
      this.setState({ waitingForDeliveryRequest: true });
    }

    this._savePersistedState(
      persistedStateConfig.template,
      this.state,
      persistedStateConfig.persistorPrefix
    );

    var missingSkuClose = !this.state.missingBoxItem && !!prevState.missingBoxItem;
    var warningClose = !this.state.warningModalOpen && prevState.warningModalOpen;
    var finalizeSortModalClose =
      !this.state.finalizeSortModalOpen && prevState.finalizeSortModalOpen;
    var inputWasDisabled = !this.state.scanDisabled && prevState.scanDisabled;
    var rxValidationClosed = !this.state.showRxOrder && prevState.showRxOrder;
    var validateShippingLabelClosed =
      !this.state.verifyShippingLabelOpen && prevState.verifyShippingLabelOpen;
    var partialDeliveryConfirmationModalClosed =
      !this.state.partialDeliveryConfirmationModalOpen &&
      prevState.partialDeliveryConfirmationModalOpen;

    var singleWaiting =
      (this.props.cartState.isSingleCart || this._getIsVagnSingleMode()) &&
      (this.state.waitingForEjectReport || this.state.finalizePending);
    var singleWasWaiting =
      prevProps.cartState.isSingleCart &&
      (prevState.waitingForEjectReport || prevState.finalizePending);

    var singleChange = !singleWaiting && singleWasWaiting;

    var modalWasClosed = [
      warningClose,
      missingSkuClose,
      finalizeSortModalClose,
      inputWasDisabled,
      rxValidationClosed,
      validateShippingLabelClosed,
      singleChange,
      partialDeliveryConfirmationModalClosed,
    ].some((x) => x);

    if (modalWasClosed) {
      this._setInputFocus();
    }

    if (UtilMethods.IsAutoPack(this.props.loginState.workstationType)) {
      this._startSignalR(prevState);
    }
    this._gsCharInputFix();
  }

  _updateLockExpiration = () => {
    if (this.state.currentSortBoxID !== -1) {
      this.updateLockExpirationTimeoutID = sortBoxLockExpirationUtil.updateLockExpiration(
        this.state.currentSortBoxID
      );
    }
  };

  _extendSortBoxLockExpiration = (sortBoxID) => {
    sortBoxLockExpirationUtil.extendSortBoxLockExpiration(sortBoxID);
  };

  _clearUpdateLockExpiration = () => {
    if (this.updateLockExpirationTimeoutID) {
      sortBoxLockExpirationUtil.clearUpdateLockExpiration(this.updateLockExpirationTimeoutID);
      this.updateLockExpirationTimeoutID = null;
    }
  };

  _pollForIPackBox() {
    if (this.state.waitingForNewIPackBox) {
      var setPollTimeout = () => {
        setTimeout(this._pollForIPackBox, 10000);
      };
      IPackEndpoints.pollForBox().then(setPollTimeout).catch(setPollTimeout);
    }
  }

  _pollForIsPackingAllowed = async () => {
    if (!this.state.warningModalOpen) {
      try {
        const operatorID = this.props.loginState.operatorID;
        const allowed = await WorkstationEndpoints.isPackingAllowedInWorkstation(
          this.props.loginState.workstationID
        );
        if (this.props.appState.packingAllowed !== allowed) {
          this.props.setPackingAllowed(allowed);
        }

        if (!allowed) {
          if (operatorID > 0 && !this.state.isPartialDelivery) {
            await this._signOut(() => this.props.setPackingAllowed(false));
          }
        }
      } catch (err) {
        //console.log(err)
      }
    }
  };

  _getWarningModalOnCloseFunctionByKey = (key) => {
    switch (key) {
      case Constants.WarningModalOnCloseFunctionKey.Logout:
        return (desciredCartID) => {
          this._handleWarningModalClose(desciredCartID);
          this._signOut();
        };
      default:
        return this._handleWarningModalClose.bind(this);
    }
  };

  _pollForInstruction = async () => {
    if (
      !this.state.warningModalOpen &&
      this.state.nextAction === ActionTypes.SET_CART &&
      this.props.cartState.currentCart === -1
    ) {
      try {
        const instruction = await this._checkForInstruction();
        if (instruction.desiredCartId > -1 && instruction.desiredCartId) {
          this._changeCart(instruction.desiredCartId, true, false, instruction);
        }
      } catch (err) {
        //console.log(err)
      }
    }
  };



  _setInputFocus() {
    if (this.inputRef && this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }

  _setBoxDeliveryCallback() {
    SignalR.setBoxDeliveryCallback((data) => {
      //console.log(data);
      if (!this.state.waitingForDeliveryRequest || this.state.waitingForNewIPackBox) {
        if (this.props.loginState.workstationID > 0) {
          IPackEndpoints.failureToDeliver(data.Message);
        } else {
          document.location.reload();
        }
      } else if ((this._allItemsVerified() || this._someItemsVerified()) && this.state.isPartialDelivery) {
        this.setState(
          {
            iPackBoxBarcode: data.Message,
          },
          () => {
            this._performPartialDelivery();
          }
        );
      } else if (this._allItemsVerified()) {
        this._finalizeBox(data.Message);
      } else if (this._someItemsVerified() && !this.state.isPartialDelivery) {
        this.setState({
          partialDeliveryConfirmationModalOpen: true,
          iPackBoxBarcode: data.Message,
        });
      }
    });
  }

  _manualPartialDelivery = () => {
    this.setState({
      isPartialDelivery: true,
      partialDeliveryConfirmationModalOpen: false,
    });
  };

  _setBoxErrorCallback() {
    SignalR.setBoxErrorCallback((data) => {
      //console.log(data);
      this.setState({
        showBoxErrorModal: true,
        boxErrorHeader: "Kunde inte läsa lådan!",
        boxErrorMessage: "Plocka bort lådan och håll ner knapparna för ny låda.",
      });
    });
  }

  _setShowErrorCallback() {
    SignalR.setShowErrorCallback((message) => {
      var boxErrorTypes = [ClientMessageType.ERROR_BOX_READ, ClientMessageType.ERROR_BOX_USED, ClientMessageType.ERROR_BOX_UNDEFINED];

      if (boxErrorTypes.includes(message.MessageType)) {
        var header = "Kunde inte läsa streckkod!";
        var errorMessage = "Säg till ansvarig & håll ner knapparna för ny låda.";

        if (message.MessageType === ClientMessageType.ERROR_BOX_USED) {
          header = "Lådan har redan använts!";
          errorMessage =
            "Säg till ansvarig & byt streckkod på lådan. Håll ner knapparna för ny låda.";
        }

        if (message.MessageType === ClientMessageType.ERROR_BOX_UNDEFINED) {
          header = "Ingen låda registrerad!";
          errorMessage =
            "Håll ner knapparna för ny låda, eller scanna ny manuellt.";
        }

        this.setState({
          showBoxErrorModal: true,
          boxErrorMessage: errorMessage,
          boxErrorHeader: header,
        });
      } else {
        alert(message.Message);
      }
      this.setState({
        boxError: message,
      });
    });
  }
  _setBoxEjectCallback() {
    SignalR.setBoxEjectCallback((data) => {
      var closeMessage = false;
      if (this.state.warningMessage === EJECT_ERROR_MESSAGE && this.state.warningModalOpen) {
        closeMessage = true;
      }
      this.setState({
        waitingForEjectReport: false,
        warningModalOpen: closeMessage ? false : this.state.warningModalOpen,
      });
    });
  }
  _setBoxResetCallback() {
    SignalR.setBoxResetCallback((data) => {
      //console.log("box reset callback", data);
    });
  }

  _setBoxAtTableCallback() {
    SignalR.setBoxAtTableCallback((data) => {
      var closeMessage = false;
      if (this.state.warningMessage === EJECT_ERROR_MESSAGE && this.state.warningModalOpen) {
        closeMessage = true;
      }

      this.setState(
        {
          waitingForNewIPackBox: false,
          nextAction:
            this.state.nextAction === ActionTypes.INITIALIZE_BOX_CHECK
              ? this.props.cartState.isSingleCart || this._getIsVagnSingleMode()
                ? ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN
                : ActionTypes.GET_SHELF
              : this.state.nextAction,
          warningModalOpen: closeMessage ? false : this.state.warningModalOpen,
        },
        this._performNextAction
      );
    });
  }

  _boxRemovedCallback() {
    this.setState(
      {
        showBoxErrorModal: false,
      },
      () => {
        this._setInputFocus();
      }
    );
  }
  _startSignalR(prevState) {
    if (
      this.state.operatorID !== -1 &&
      (!prevState || prevState.operatorID === -1) &&
      !SignalR.isRunning() &&
      Constants.RUN_SIGNALR
    ) {
      SignalR.start(this.props.loginState.workstationID);
    }
  }

  _boxStarted() {
    return this.state.boxItems.some((bi) => bi.verifiedQuantity > 0);
  }

  _partialStarted = () => {
    return this.state.boxItems.some((bi) => bi.partialQuantity > 0) && this.state.isPartialDelivery;
  };

  _pollForInactivity() {
    setInterval(() => {
      if (
        (!this._boxStarted() && !this._partialStarted()) &&
        StatePersistor.isStateInactive(
          persistedStateConfig.lifespanSeconds,
          persistedStateConfig.decidingKey,
          persistedStateConfig.persistorPrefix
        )
      ) {
        this._signOut();
      }
    }, 1000);
  }

  _versionCheckPoll = () => {
    this._versionCheckInterval = setInterval(
      () =>
        checkVersion((value) => {
          if (value !== this.props.appState.shouldRedirect) {
            this.props.setShouldRedirect(value);
          }
        }),
      20000
    );
  };

  _partialDeliveryConfirmationModalCallback = (isManual) => {
    const hasAccess = this.props.loginState.partialDeliveryAccess;

    this.setState({
      partialDeliveryConfirmationModalOpen: false,
    });

    if (hasAccess) {
      if (isManual) {
        this._manualPartialDelivery();
      } else {
        this._performPartialDelivery();
      }
    } else {
      this.setState({
        verifyPartialDelivery: true,
      });
    }
  };

  _partialDeliveryAccessCheck = (scannedID, successCallback, failureCallback) => {
    OperatorEndpoints.canPartialDeliver(scannedID)
      .then((hasAcces) => {
        if (hasAcces) {
          this.setState({
            verifyPartialDelivery: false,
          });
          successCallback();
          const isManual = UtilMethods.IsManualPack(this.props.loginState.workstationType);
          if (isManual) {
            this._manualPartialDelivery();
          } else {
            this._performPartialDelivery();
          }
        } else {
          const data = {
            message: "Behörighet saknas!",
          };
          failureCallback(data);
        }
      })
      .catch((err) => {
        const data = {
          message: "Behörighet saknas!",
        };
        failureCallback(data);
      });
  };

  _performPartialDelivery() {
    this.setState(
      {
        isPartialDelivery: true,
      },
      () => {
        let scannedItems = this.state.boxItems.filter((bi) => bi.partialQuantity > 0);
        scannedItems = SharedFunctions.mergeItems("skuID", scannedItems);
        this._finalizeBox(this.state.iPackBoxBarcode, scannedItems);
      }
    );
  }

  _performNextAction(input, inputType) {
    const appMode = this.props.appState.appMode;
    const cartSuggestion = this.props.cartState.cartSuggestion;
    let { nextAction, isPartialDelivery } = this.state;
    var isCartOnArticle =
      inputType === Constants.SCAN_INPUT_TYPE_CART &&
      [ActionTypes.SCAN_ARTICLE].includes(nextAction);
    var isDoubleDigit = /^\d{2}$/.test(input);
    var isNotStarted = !this._boxStarted();
    const partialDeliveryAllowed = this.state.partialDeliveryAllowed;
    const isManual = UtilMethods.IsManualPack(this.props.loginState.workstationType);
    if (
      isCartOnArticle &&
      isDoubleDigit &&
      isNotStarted &&
      !isPartialDelivery &&
      appMode !== ApplicationMode.BoxReviewMode
    ) {
      this._getNextSortBox(null, input);
      return;
    }

    if (inputType === Constants.SCAN_INPUT_TYPE_BOXBARCODE) {
      this._setScannedBoxManually(input);
      return;
    }

    switch (nextAction) {
      case ActionTypes.SET_CART:
        if (input === undefined && cartSuggestion === -1) return;
        if (cartSuggestion > -1) {
          this._handleCartScan("V" + cartSuggestion);
        } else if (inputType === Constants.SCAN_INPUT_TYPE_CART) {
          this._handleCartScan(input);
        } else {
          this._showWarningModal(
            "Förväntades scanning av ny vagn!",
            PERFORM_NEXT_ACTION_SET_CART_ERROR_CODE
          );
        }
        break;

      case ActionTypes.GET_SHELF:
        this._getNextSortBox();
        break;

      case ActionTypes.SCAN_ARTICLE:
        if (input && inputType && !this.state.waitingForEjectReport) {
          this._handleArticleScan(input, inputType);
        } else if (this._allItemsVerified()) {
          if (isManual) {
            if (appMode === ApplicationMode.BoxReviewMode) {
              this.props.reloadBoxReview(false);
            }
            if (!this.state.boxItems.filter((bi) => bi.requireWeighing).length) {
              this._finalizeBox();
            } else {
              this.setState({ waitingforMeasurement: true });
            }
          } else {
            if (!this.state.boxItems.filter((bi) => bi.requireWeighing).length) {
              this.setState({
                waitingForDeliveryRequest: true,
              });
            } else {
              this.setState({ waitingforMeasurement: true });
            }
          }
        }
        else if (
          this._someItemsVerified() &&
          !isManual &&
          partialDeliveryAllowed
        ) {
          this.setState({
            waitingForDeliveryRequest: true,
          });
        }
        break;

      case ActionTypes.INITIALIZE_BOX_CHECK:
        this._getIPackBoxIDAtWorkstation();
        break;

      case ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN:
        this._handleSingelArticleScan(input, inputType);
        break;

      case ActionTypes.SEARCH_BOX:
        if (input === undefined) {
          return;
        }

        if (
          inputType === Constants.SCAN_INPUT_TYPE_BOXID ||
          inputType === Constants.SCAN_INPUT_TYPE_FAKTURA
        ) {
          this._handleBoxScan(input);
        } else {
          this._showWarningModal(
            "Förväntades scanning av lådas fakturanummer eller ID",
            PERFORM_NEXT_ACTION_SEARCH_BOX_ERROR_CODE
          );
        }

        break;

      default:
        if (input) {
          this._showWarningModal(
            "Vi lyckades inte se vad du scannade, testa igen",
            PERFORM_NEXT_ACTION_DEFAULT_ERROR_CODE
          );
        }
        break;
    }
  }

  _savePersistedState(template, state, prefix) {
    let stateMatch = {};
    Object.keys(template).forEach((key) => (stateMatch[key] = state[key]));
    StatePersistor.insertState(stateMatch, prefix);
  }

  _onInputKeyPress(e) {
    if (e.key !== "Enter") {
      return;
    }

    // Om man hunnit scanna alla artiklar trots att man fortfarande inte fått en ny lådresarlåda ska man inte kunna scanna mer
    if (
      UtilMethods.IsAutoPack(this.props.loginState.workstationType) &&
      this._hasBox() &&
      this._allItemsVerified() &&
      this.state.waitingForEjectReport
    ) {
      return;
    }

    var targetCopy = e.target;

    this.setState(
      {
        scanDisabled: true,
      },
      () => {
        setTimeout(() => this.setState({ scanDisabled: false }), 50);
        this._submitInput(targetCopy);
      }
    );
  }

  _submitInput(targetRef) {
    let input = targetRef.value.trim().toUpperCase();
    let inputType = UtilMethods.ParseInputType(input);
    
    if(inputType == Constants.SCAN_INPUT_TYPE_2D){
      input = targetRef.value.trim();
    }

    this._performNextAction(input, inputType);

    targetRef.value = "";
  }

  _handleSingelArticleScan(input, inputType, boxID) {
    if (input && inputType) {
      let isRXBag = this._isRXBagEAN(input, inputType);

      if (isRXBag) {
        SharedFunctions.LogScannedRXBag(input);
      }

      this._getNextSortBox(input, boxID);
    } else {
      this.setState({ scanDisabled: false });
    }
  }
  _onKeyPadClick(key) {
    var inputRefEl = this.inputRef.current;

    if (key === KeyPadKeyCode.ENTER) {
      this._submitInput(inputRefEl);
    } else if (key === KeyPadKeyCode.BACKSPACE) {
      if (this.inputRef && inputRefEl && inputRefEl.value.length) {
        var currentValue = inputRefEl.value;
        inputRefEl.value = currentValue.substr(0, currentValue.length - 1);
      }
    } else if (key || key === KeyPadKeyCode.ZERO) {
      if (this.inputRef && inputRefEl) {
        inputRefEl.value += key;
      }
    }
  }

  //THIS SHOULD BE REMOVED WHEN NEXT ACTION IS IN REDUX!:()
  _setCart() {
    this._loadSingleItems(this.props.cartState.currentCart, -1)
      .then(() => {
        var nextAction = this.state.waitingForNewIPackBox
          ? ActionTypes.INITIALIZE_BOX_CHECK
          : this.props.cartState.sortType === SortType.SINGEL ||
            this.props.cartState.sortType === SortType.AFRAMEMIXEDSINGLE ||
            this._getIsVagnSingleMode()
            ? ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN
            : ActionTypes.GET_SHELF;
        this.setState(
          {
            nextAction: nextAction,
          },
          () => {
            this._performNextAction();
          }
        );
        this._getPackagingType();

        if(this.props.cartState.hasHelpPicklist){
          this._showWarningModal(
            "Denna vagn har hjälpplockats, kontrollera att alla varor finns i vagnen.",
            PERFORM_NEXT_ACTION_SET_CART_ERROR_CODE,
            "Hänvisning"
          );
        }

      })
      .catch((error) => {
        console.log(`Ett fel inträffade vid hämtninga av singlar: ${error}`);
      });
  }

  _setStateWaitingForSingleArticleScan() {
    this.setState(
      {
        currentShelfNumber: 51,
        waitingForDeliveryRequest: false,
        currentOrderNumber: -1,
        currentSortBoxID: -1,
        nextAction: ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN,
        boxItems: [],
        forceShelf: null,
        isPartialDelivery: false,
        partialDeliveryContinued: false,
        partialDeliveryStarted: false,
        wasCancelled: false,
        iPackBoxBarcode: null,
        iPackBoxID: -1,
      },
      () => {
        this._performNextAction();
      }
    );
  }

  _closeFinalizeSortModal() {
    this.setState(
      {
        waitingForDeliveryRequest: false,
        finalizePending: false,
        finalizeSortModalOpen: false,
      },
      this.props.toggleLoading(false)
    );
    this._clearCartState();
    this._performNextAction();
  }

  _handleBoxScan(input) {
    const isInputSupported = /^[F|X]\d{9}$/g; // Prob an unncessary check coming all the way from '_performNextAction'.

    if (isInputSupported.test(input.trim())) {
      return;
    }

    this.props.toggleLoading(true);

    BoxLookupEndpoints.getBox(BoxLookupConstants.LookupValueOrigin.ScannedBarcode, input)
      .then((sb) => {
        new SortBox(input, -1, sb, this).load();

        // TODO (Refactor): Hacky, but I don't want the next action derived further down the call stack
        /**
         * This flag influences so far:
         *   - _cancelSortBox
         *   - How the right bar is rendered, checked in addition to this.state.currentCart
         */
        this.setState({ boxLookupApplicationMode: true });
      })
      .catch(this._addError);
  }

  _handleCartScan(input) {
    this.props.toggleLoading(true);
    this.props.scanCartID(input);
    this.props.fetchCartData(
      () => this._setCart(),
      () => this._showWorkstationInstruction(),
      (message, error, header) => this._showWarningModal(message, error, header)
    );
  }

  _addError(error) {
    this.props.setError({
      message: error.message,
      visible: true,
      errorType: -1,
    });
    this.props.toggleLoading(false);
  }

  // Tar bort allt som har med sortcart och sortbox att göra
  // TODO: (Refactor/Tests) Extract out to util and write tests.
  _clearCartState() {
    this.setState({
      ...cartState,
    },() => { console.log(this.state) 
      console.log("¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤¤");
    })
  }

  _getNextSortBox(scan, forceShelf = -1) {
    if (this.props.appState.shouldRedirect) {
      this.props.setShouldRedirect(false);
      this._signOut();
      return;
    }

    this.props.toggleLoading(true);
    scan = scan || "";

    var fs = forceShelf;

    if (forceShelf > -1) {
      fs = forceShelf;
    } else {
      fs = this.state.forceShelf || fs;
    }

    fs = parseInt(fs);

    if (fs > -1) {
      this.setState({ forceShelf: fs });
    }
    const { currentSortBoxID, packingPrioDeadlineId, lastInstruction } = this.state;
    const currentCart = this.props.cartState.currentCart;
    const lastInstructionID = lastInstruction ? lastInstruction.id : -1;
    SortBoxEndpoints.getNextSortBox(
      currentCart,
      currentSortBoxID,
      scan,
      fs,
      packingPrioDeadlineId,
      lastInstructionID
    )
      .then((sb) => new SortBox(scan, fs, sb, this).load())
      .catch((error) => {
        this._addError(error);
        this.setState({
          scanDisabled: false,
        });
      })
      .finally(() => {
        this.props.toggleLoading(false);
        this._setInputFocus();
      });
  }

  _changeCart(
    cartSuggestion = -1,
    hasIntruction = false,
    triggerNextAction = true,
    instruction = void 0
  ) {
    var completionCallback = async () => {
      if (triggerNextAction) {
        this._performNextAction();
      } else {
        const currentCart = this.props.cartState.currentCart;
        if (cartSuggestion && parseInt(cartSuggestion) === -1 && !hasIntruction) {
          instruction = await this._checkForInstruction();
        }
        if (
          instruction &&
          instruction.desiredCartId > -1 &&
          currentCart === instruction.desiredCartId
        ) {
          instruction.message = `Fortsätt packa vagn ${currentCart}`;
          instruction.desiredCartId = -1;
          instruction.visible = true;
          this.props.setCurrentInstruction(instruction, () => this._showWorkstationInstruction());
        } else {
          if (instruction && instruction.desiredCartId > -1) {
            instruction.visible = true;
            this.props.setCurrentInstruction(instruction, () => this._showWorkstationInstruction());
          }
          this.props.clearCartState();
          this._clearCartState();
          this.props.setCartSuggestion(cartSuggestion);
          this.props.wasCancelled(false);
          this.setState({
            waitingForDeliveryRequest: false,
            nextAction: ActionTypes.SET_CART,
            forceShelf: null,
            cartContent: null,
            isCartInstruction: true,
          });
        }
      }
    };

    this._clearUpdateLockExpiration();
    OperatorEndpoints.clearPendingInstructions().then(completionCallback).catch(completionCallback);
  }

  /**
   * Handles the action when the User presses the bottom-right
   * menu to search a box 'Hitta Låda'.
   */
  _searchBox() {
    var completionCallback = () => {
      this.props.clearCartState();
      this.props.wasCancelled(false);
      this.props.setCartSuggestion(-1);
      this._clearCartState();
      this.setState({
        waitingForDeliveryRequest: false,
        nextAction: ActionTypes.SEARCH_BOX,
        forceShelf: null,
        cartContent: null,
      });
      this._performNextAction();
    };

    this._clearUpdateLockExpiration();
    OperatorEndpoints.clearPendingInstructions().then(completionCallback).catch(completionCallback);
  }

  _checkForInstruction() {
    let workstationID = this.props.loginState.workstationID;
    return OperatorEndpoints.getWorkstationInstruction(workstationID)
      .then((result) => {
        return result;
      })
      .catch((error) => {
        this._addError(error);

        const instruction = {
          desiredCartId: -1,
        };
        return instruction;
      });
  }

  _showWorkstationInstruction() {
    const instruction = this.props.instructionState.currentInstruction;
    let warningMessage = instruction?.message || "Något gick fel";
    let warningHeader = instruction?.message ? "Hänvisning" : null;
    let warningClass = "warning-modal-instruction";
    const currentCart = this.props.cartState.currentCart;
    if (instruction && instruction.desiredCartId > -1) {
      this._setCartSuggestion(instruction);

      const showReparkMessage = operatorInstructionUtil.shouldRepark(instruction, currentCart);

      if (showReparkMessage) {
        warningMessage = operatorInstructionUtil.getReparkMessage(instruction);
        operatorInstructionUtil.reparkCart(instruction, currentCart);
      }

      this._showWarningModal(
        warningMessage,
        SHOW_WORKSTATION_INSTRUCTION_ERROR_CODE,
        warningHeader,
        warningClass,
        false,
        true
      );
    } else {
      this._showWarningModal(
        warningMessage,
        SHOW_WORKSTATION_NO_INSTRUCTION_ERROR_CODE,
        warningHeader,
        warningClass,
        false
      );
    }
  }

  _refreshSingleItemsGrid(currentSortBoxId) {
    let singleItems = this.state.singleItems;
    singleItems = singleItems.sort((i) => {
      if (i.boxID === currentSortBoxId) {
        return -1;
      } else {
        return 1;
      }
    });
    this.setState({
      singleItems: singleItems,
    });
  }

  _getSkuIDFromInput(input, scanInputType, callback) {
    var boxLookupEAN = (ean) => {
      let boxItem = this.state.boxItems.find((bi) => {
        return bi.eans.map((e) => e.trim()).indexOf(ean) > -1;
      });

      if (boxItem) return boxItem.skuID;

      return -1;
    };

    if (scanInputType === Constants.SCAN_INPUT_TYPE_EAN) {
      callback(boxLookupEAN(input));
    } else if (scanInputType === Constants.SCAN_INPUT_TYPE_SKU) {
      callback(parseInt(input.substring(1)));
    } else if (scanInputType === Constants.SCAN_INPUT_TYPE_2D) {
      SkuEndpoints.GetEANFrom2D(input).then((ean) => callback(boxLookupEAN(ean)));
    }
  }
  _getArticleScanWarningMessage(boxItem, inputType, isRXBag) {
    var correctInputs = [
      Constants.SCAN_INPUT_TYPE_EAN,
      Constants.SCAN_INPUT_TYPE_SKU,
      Constants.SCAN_INPUT_TYPE_2D,
    ];
    if (correctInputs.indexOf(inputType) === -1) return "Felaktig scanning.";
    if (!boxItem && isRXBag) return "bad_rx_bag";
    if (!boxItem) return "Artikeln finns inte på ordern";
    if (boxItem.verifiedQuantity === boxItem.reservedQuantity)
      return `Du har redan scannat ${boxItem.verifiedQuantity}/${boxItem.verifiedQuantity} ${boxItem.name}.`;
    if (boxItem.skuID > 70000000 && inputType !== Constants.SCAN_INPUT_TYPE_EAN)
      return "RX-påse måste skannas!";
    return "";
  }

  _getNextSortBoxItem(skuID, checkWeight = true) {
    var getWeight = (toCheck) => toCheck.reservedQuantity - toCheck.verifiedQuantity;
    let boxItem = this.state.boxItems
      .filter((bi) => bi.skuID === skuID && (!checkWeight || getWeight(bi) !== 0))
      .sort((a, b) => {
        var compare = (a, b) => (a > b) - (a < b);
        return (
          compare(getWeight(a), getWeight(b)) || compare(a.verifiedQuantity, b.verifiedQuantity)
        );
      })[0];

    if (checkWeight && !boxItem) {
      return this._getNextSortBoxItem(skuID, false);
    } else {
      return boxItem;
    }
  }

  _showRXWarningModal() {
    this.setState({
      showRxOrder: true,
    });
  }

  _isRXBagEAN(input, scanInputType) {
    ////console.log("Scanned " + input + scanInputType)
    let isRXBag = false;
    let rxEAN = input.slice(0, 5);

    if (scanInputType === Constants.SCAN_INPUT_TYPE_EAN && parseInt(rxEAN) === 39907) {
      isRXBag = true;
    }
    return isRXBag;
  }

  _handleArticleScan(input, scanInputType, origin = "") {
    if (origin === "click") {
      let now = new Date().getTime();
      let timeToWait = 1500;
      let failedParsing = false;
      let skuID = 0;
      try {
        skuID = parseInt(input.split("K")[1]);
      } catch (e) {
        failedParsing = true;
      }

      if (
        !failedParsing &&
        this.state.lastClickScan &&
        this.state.lastClickScanSku !== skuID &&
        this.state.lastClickScan + timeToWait > now
      ) {
        this.setState({
          lastClickScan: now,
        });
        return;
      }

      let boxItem = this._getNextSortBoxItem(skuID);
      if (
        !failedParsing &&
        boxItem &&
        boxItem.verifiedQuantity < boxItem.reservedQuantity &&
        boxItem.reservedQuantity > 1 &&
        this.state.boxItems &&
        this.state.boxItems.length > 1
      ) {
        this.setState({
          lastClickScan: now,
          lastClickScanSku: skuID,
        });
      }
    }

    this._getSkuIDFromInput(input, scanInputType, (skuID) => {
      const currentSkuID = skuID;
      let boxItem = this._getNextSortBoxItem(skuID);
      let isRXBag = this._isRXBagEAN(input, scanInputType);
      let warning = this._getArticleScanWarningMessage(boxItem, scanInputType, isRXBag);
      if (isRXBag) {
        SharedFunctions.LogScannedRXBag(input);
      }
      if (warning !== "bad_rx_bag" && warning) {
        var cartId = this.props.cartState.currentCart.toString();
        cartId = cartId.substring(0, cartId.length - 1);
        SharedFunctions.LogPopupShownEvent({
          modalComponentName: WARNING_MODAL,
          state: JSON.stringify({ "unknown_ean": input, scanInputType: scanInputType, cartShelfNumber: this.state.currentShelfNumber }),
          skuId: -1,
          orderNumber: this.state.currentOrderNumber,
          quantity: 1,
          cartId: cartId
        });
        return this._showWarningModal(warning, GET_SKU_ID_FROM_INPUT_ERROR_CODE);
      }
      if (isRXBag && warning === "bad_rx_bag") return this._showRXWarningModal();

      skuID = boxItem.skuID;
      if (boxItem.eVerificationRequired && scanInputType !== Constants.SCAN_INPUT_TYPE_2D) {
        var message = "2D kod (QR-kod) måste skannas på denna vara.";
        this._showWarningModal(message, SCAN_INPUT_TYPE_2D_ERROR_CODE);
        return;
      }

      if (scanInputType === Constants.SCAN_INPUT_TYPE_2D) {
        var scan = new TwoDScan(this, skuID, input);
        this.props.toggleLoading(true);

        scan
          .sendEverificationScan()
          .then((result) => {
            if (result.success) {
              this._performNextAction();
            } else {
              this._showWarningModal(result.message, SEND_EVERIFICATION_SCAN_ERROR_CODE);
            }
          })
          .finally(() => {
            this.props.toggleLoading(false);
          });
      } else {
        if (boxItem.verifiedQuantity >= boxItem.confirmedQuantity) {
          this.setState({ lastScannedSKU: skuID });
          this._performNextAction();
          return;
        }
        if (!this.state.deliveryStarted) {
          this.setState({
            deliveryStarted: true,
          });
        }
        boxItem.verifiedQuantity++;
        boxItem.partialQuantity++;
        this.setState(
          {
            boxItems: this.state.boxItems.map((bi) => (bi === boxItem ? boxItem : bi)),
            lastScannedSKU: skuID,
          },
          this._performNextAction
        );
      }
    });
  }

  _skuIsMissing(skuID, shelfNumber, orderItem) {
    var boxItem = {};
    if (orderItem) {
      boxItem = {
        ...orderItem,
        skuID,
        shelfNumber,
      };
    } else {
      if (this.props.appState.appMode === ApplicationMode.AFrameReviewMode){
        boxItem = this.state.boxItems.find(
          (bi) => bi.skuID === skuID && bi.shelfNumber === shelfNumber
        );
      }else{
        boxItem = this._getMergedBoxItems().find(
          (bi) => bi.skuID === skuID && bi.shelfNumber === shelfNumber
        );
      }

      if (!boxItem) return;
      var tempBoxItem = { ...boxItem };

      if (
        (this.props.cartState.isSingleCart || this._getIsVagnSingleMode()) &&
        boxItem.reservedQuantity === 1
      ) {
        boxItem = tempBoxItem;
        boxItem.verifiedQuantity = 0;
      }
    }

    this.setState({
      missingBoxItem: boxItem,
    });
  }

  _dismissMissingSku(callback) {
    this._updateStateUponMissingSkuModalClose();
    if (callback) callback();
  }

  _updateStateUponMissingSkuModalClose() {
    this.setState(
      {
        missingBoxItem: "",
      },
      () => {
        var boxItems;
        if (this.props.appState.appMode === ApplicationMode.AFrameReviewMode){
          boxItems = this.state.boxItems;
        }else{
          boxItems = this._getMergedBoxItems();
        }
        const workstationType = this.props.loginState.workstationType;
        const isAutoPack = UtilMethods.IsAutoPack(workstationType);
        if (
          (!boxItems.length || (this._allItemsVerified() && this.state.isPartialDelivery)) &&
          !this.props.cartState.isSingleCart && !(this._getIsVagnSingleMode())
        ) {
          if (this.state.isPartialDelivery && boxItems.length) {
            if (this._someItemsVerified()) {
              if (isAutoPack) {
                this.setState({
                  waitingForDeliveryRequest: true
                })
              } else {
                this._performPartialDelivery();
              }
            } else {
              this._finalizeBox();
            }
          } else {
            if (!boxItems.length && this.props.cartState.sortType === SortType.AFRAMEMIXEDNORMAL) {
              // check if aframemixed and display instruction to deliver empty ipackbox
              this.setState({
                waitingForDeliveryRequest: true,
                finalizeEmpty: true,
              });

              return;
            }

            this.setState(
              {
                nextAction: ActionTypes.GET_SHELF,
              },
              this._performNextAction
            );
          }
        } else if (this._allItemsVerified()) {
          if (boxItems.length && (this.props.cartState.isSingleCart || this._getIsVagnSingleMode()) && this.state.isPartialDelivery) {
            if (this._someItemsVerified()) {
              if (isAutoPack) {
                this.setState({
                  waitingForDeliveryRequest: true
                })
              } else {
                this._performPartialDelivery();
              }
            } else {
              this._finalizeBox();
            }
          } else {
            this._performNextAction();
          }
        } else if (
          (this.props.cartState.isSingleCart || this._getIsVagnSingleMode()) &&
          !boxItems.length
        ) {
          this._reloadSingels();
        }
      }
    );
  }

  _reloadSingels = () => {
    this.setState(
      {
        nextAction: ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN,
        waitingForDeliveryRequest: false,
        currentOrderNumber: -1,
        currentSortBoxID: -1,
        currentShelfNumber: -1,
      },
      () => {
        this._loadSingleItems(this.props.cartState.currentCart, this.state.currentSortBoxID).then(
          this._performNextAction
        );
      }
    );
  };

  // true if all boxitems are verified
  _allItemsVerified(items) {
    items = items || this.state.boxItems;

    return !items.some((bi) => bi.verifiedQuantity < (bi.reservedQuantity - bi.missingQuantity) && (bi.skuID < Constants.RX_BAG_SKU || !this.props.aframeReviewState.rxFloorVisited ));
  }

  // true if some items have been verified/partially delivered.
  _someItemsVerified() {
    return this.state.boxItems.some((bi) => bi.partialQuantity > 0);
  }

  // kollar om vi har ett fack valt just nu
  _hasBox() {
    return (
      this.props.cartState.currentCart > -1 &&
      this.state.currentShelfNumber > -1 &&
      this.state.currentSortBoxID > -1 &&
      this.state.currentOrderNumber > 0
    );
  }

  // Stänger errormodalen och fokuserar inputfältet
  _handleWarningModalClose() {
    this.setState({
      warningModalOpen: false,
      warningMessage: "",
      warningHeader: "",
      warningClass: "",
      warningAutoClose: false,
      isCartInstruction: false,

      warningButtonText: null,
      warningErrorCode: null,
      warningOnCloseFunctionKey: null,
    });
    document.getElementById("ScanInputField").focus();
  }

  _showWarningModal(
    message,
    errorCode,
    header = "Felaktig scan",
    warningClass = "",
    warningAutoClose = false,
    isCartInstruction = false,
    buttonText = null,
    onCloseFunctionKey = null
  ) {
    this.setState({
      warningModalOpen: true,
      warningMessage: message,
      warningHeader: header,
      warningClass: warningClass,
      warningAutoClose: warningAutoClose,
      isCartInstruction: isCartInstruction,
      warningButtonText: buttonText,
      warningOnCloseFunctionKey: onCloseFunctionKey,
      warningErrorCode: errorCode,
    });
  }

  _updateSortBoxItems(newBoxItems) {
    if (newBoxItems && newBoxItems.length && !newBoxItems[0].isRxItem && this.state.currentSortBoxID !== newBoxItems[0].boxID) {
      if (this.props.cartState.isSingleCart || this._getIsVagnSingleMode()) {
        // check if aframemixed and display instruction to deliver empty ipackbox
        if (
          ((this.props.cartState.sortType === SortType.AFRAMEMIXEDSINGLE) || (this._getIsVagnSingleMode() && newBoxItems[0].isPrefillSortBox)) &&
          newBoxItems.every((bi) => bi.reservedQuantity === 0)
        ) {
          this.setState({
            waitingForDeliveryRequest: true,
            finalizeEmpty: true,
            currentSortBoxID: newBoxItems[0].boxID,
          });
        } else {
          this._loadSingleItems(this.props.cartState.currentCart, this.state.currentSortBoxID);
        }
      }
      
      return;
    }

    var mergedItems = SharedFunctions.getUpdatedBoxItems(newBoxItems, this.state.boxItems);
    if (this.props.appState.appMode === ApplicationMode.AFrameReviewMode){
      const newAllSortboxItems =  UtilMethods.GetAllSortboxItemsHandleUpcomingPickAutomation(this.props.aframeReviewState.allSortBoxItems, this.state.missingBoxItem,this.state.boxItems, mergedItems, newBoxItems);
      let allSortBoxItemsSorted = sortAllSortBoxItemsByExistingSortboxItems(newAllSortboxItems, this.state.boxItems);
      this.props.setAllSortboxItems(allSortBoxItemsSorted);
      this.props.setAframeSortboxItems(mergedItems);
    }

    this.setState({
      boxItems: mergedItems,
    });
  }

  _clearOrder() {
    this.setState({
      boxItems: [],
      currentOrderNumber: -1,
      currentShelfNumber: -1,
      currentSortBoxID: -1,
    });
  }

  async _signOut(callback) {
    if (!callback || typeof callback !== "function") {
      callback = () => { };
    }

    var date = new Date();
    let logoutTime = date.getTime();

    const newState = persistedStateConfig.template;
    newState.logoutTime = logoutTime;

    var completionCallback = async () => {
      this.props.setLoginStatus(false);
      this.props.toggleLoading(false);
      this.setState(
        {
          ...newState,
          ...initialState,
          waitingForNewIPackBox: this.state.waitingForNewIPackBox,
        },
        callback
      );
    };

    this._clearUpdateLockExpiration();
    OperatorEndpoints.clearPendingInstructions().then(completionCallback).catch(completionCallback);
  }
  _getOperatorInstruction() {
    if (this.props.appState.appMode === ApplicationMode.BoxReviewMode) {
      return "Kontrollutleverans";
    }
    let nextAction = this.state.nextAction;
    switch (nextAction) {
      case ActionTypes.SET_CART: {
        // if (this.state.cartSuggestion > -1) {
        //   return (<span>Välj vagn {this.state.cartSuggestion.toString()} <span className="GetCartSuggestion" onClick={() => this._handleCartScan(this.state.cartSuggestion.toString())}>OK</span></span>);
        // } else {
        return "Mata in vagnsnummer";
        //}
      }
      case ActionTypes.SCAN_ARTICLE:
        if (this._hasBox() && this._allItemsVerified() && this.state.waitingForNewIPackBox) {
          return "Invänta ny låda";
        }

        if (this.props.appState.appMode !== ApplicationMode.AFrameReviewMode) {
          return this.state.currentShelfNumber <= 0 && this.state.notFound
            ? "Ej packbar"
            : "Packa fack " + this.state.currentShelfNumber.toString();
        } else {
          return "AFramekontroll";
        }

      case ActionTypes.INITIALIZE_BOX_CHECK:
        if (this.state.waitingForDeliveryRequest && this._allItemsVerified()) {
          return "Tryck på knapparna";
        } else {
          return "Väntar på ny låda";
        }

      case ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN:
        return "Scanna någon artikel";

      case ActionTypes.SEARCH_BOX:
        return "Scanna Faktura eller Box Nummer";

      default:
        break;
    }
  }

  _getMergedBoxItems() {
    return SharedFunctions.mergeItems("skuID", this.state.boxItems);
  }

  async _setWorkstationID() {
    return await new Promise((resolve, reject) => {
      let workstationID = UtilMethods.getParamValue("ws");

      var rejectWrap = (e) => {
        this._addError(e);
        reject();
      };

      WorkstationEndpoints.getWorkstationInformation(workstationID)
        .then((wsResult) => {
          var wsType = wsResult.workstationType;
          let isBetaWorkstation = document.location.href.includes("preprod");
          if (!UtilMethods.IsAcceptableWorkstationType(wsType)) {
            return this._signOut(() => {
              this._addError("Felaktig arbetsstation!");
              reject();
            });
          }

          var conveyorIsSet = this.props.appState.conveyorID !== "";

          if (conveyorIsSet || UtilMethods.IsManualPack(wsType)) {
            this.props.setWorkstation(
              workstationID,
              wsType,
              wsResult.branchID,
              wsResult.autoScaleEnabled
            );
            this.props.setIsBetaWorkstation(isBetaWorkstation);
            this.props.setConveyorID(this.props.appState.conveyorID);
            return resolve();
          }

          return HomeEndpoints.getConveyorForWorkstation(workstationID)
            .then((response) => {
              this.props.setWorkstation(
                workstationID,
                wsType,
                wsResult.branchID,
                wsResult.autoScaleEnabled
              );
              this.props.setIsBetaWorkstation(isBetaWorkstation);
              this.props.setConveyorID(response);
              return resolve();
            })
            .catch(rejectWrap);
        })
        .catch(rejectWrap);
    });
  }

  _handleBoxReviewMode() {
    const { sortBoxModel, currentBox, boxReviewAction } = this.props.boxReviewState;
    this.setState({
      operatorID: this.props.loginState.operatorID,
      removeSkuAccess: true
    })
    if (sortBoxModel === null && boxReviewAction === BoxReviewActionStates.COMPLETE_BOX) {
      this._boxReviewClearState();
      return;
    } else if (this.state.currentSortBoxID === -1 && boxReviewAction === BoxReviewActionStates.PACK_MODE) {
      this._boxReviewClearState();
      return;
    }

    if (sortBoxModel !== null && boxReviewAction == BoxReviewActionStates.COMPLETE_BOX) {
      this.props.setCartID(sortBoxModel.fullCartNumber);
      this.props.setSortID(sortBoxModel.sortID);
  
      this.setState(
        {
          failureToDeliver: false,
          reviewBoxShippingMethod: currentBox.orderShippingMethod,
          nextAction: Constants.ActionTypes.SCAN_ARTICLE,
        },
        () => {
          new SortBox(null, -1, sortBoxModel, this).load();
          this.setState({
            isPartialDelivery: true,
          });
        }
      );
    }
  }

  _handleAFrameReviewMode = () => {
    const { sortBoxModel } = this.props.aframeReviewState;
    console.log(sortBoxModel);

    this.props.setCartID(-1);
    this.props.setSortID(sortBoxModel.sortID);

    this.setState(
      {
        failedToDeliver: false,
        nextAction: Constants.ActionTypes.SCAN_ARTICLE,
      },
      () => {
        new SortBox(null, -1, sortBoxModel, this).load();
      }
    );
  };

  _verifyAFrameOrderBox = () => {
    this.props.showVerifyIPackBoxBarcodeModal();
  };

  _completeAFrameOrder = (clear = false) => {
    StatePersistor.clearPersistedState(persistedStateConfig.persistorPrefix);
    this.props.finishAFrameBox(clear);
  };

  completeAFrameOrderProp = this._completeAFrameOrder.bind(this);

  _getPackagingType() {
    const conveyorID = this.props.appState.conveyorID;
    if (conveyorID !== "") {
      SettingsEndpoints.getPackagingTypeForConveyor(conveyorID)
        .then((response) => {
          if (response === Constants.PackagingTypes.Apotea) {
            setCompanyID(Constants.PackagingTypes.Apotea);
          }
          this.setState({ packagingType: response });
        })
        .catch(this._addError);
    }
  }
  // Denna körs när man loggat in
  async _setOperator(operator) {
    await this._setWorkstationID();
    let workstationID = UtilMethods.getParamValue("ws");
    let burnedDeadlineOrdersMustBePackedFirst = await WorkstationEndpoints.checkBurnedOrdersMustBePackedFirst(
      workstationID
    )
      .then((res) => {
        return res;
      })
      .catch(() => {
        return false;
      });
    this.props.setBurnedOrdersMustBePackedFirst(burnedDeadlineOrdersMustBePackedFirst);
    this.props.setAppMode(ApplicationMode.PackingMode);
    this._getPackagingType();
    let operatorID = -1;
    let operatorName = "Okänd";
    let companyID = -1;
    let removeSkuAccess = false;
    let cancelSortBoxAccess = false;
    let partialDeliveryAccess = false;

    if (typeof operator === "object") {
      operatorID = operator.operatorId;
      operatorName = operator.operatorName;
      removeSkuAccess = operator.removeSkuAccess;
      cancelSortBoxAccess = operator.cancelSortBoxAccess;
      partialDeliveryAccess = operator.partialDeliveryAccess;
      companyID = operator.companyID
    } else {
      operatorID = operator;
    }
    this.props.setUser(operatorID, operatorName, partialDeliveryAccess, companyID);

    var newWSID = this.props.loginState.workstationID;
    if (newWSID === -1 || newWSID === "-1") {
      return this._signOut();
    }

    let oldCartID = this._checkPreviousSort();
    let lastUnfinishedCartID = -1;

    if (oldCartID === -1) {
      lastUnfinishedCartID = await SortBoxEndpoints.getLastUnfinishedCartID(operatorID, newWSID)
        .then((res) => {
          return res;
        })
        .catch(() => {
          return -1;
        });
    }
    let callback = this._performNextAction;
    let forceCart = false;
    let { nextAction } = this.state;
    let instruction = await OperatorEndpoints.getWorkstationInstruction(newWSID);
    let setForceCart = (cartID) => {
      let inputType = Constants.SCAN_INPUT_TYPE_CART;
      nextAction = ActionTypes.SET_CART;
      callback = () => this._performNextAction(cartID.toString(), inputType);
      forceCart = false; //Man ska aldrig ignorera en hänvisning.
    };

    if (oldCartID !== -1) {
      setForceCart(oldCartID);
    } else if (instruction.desiredCartId > 0) {
      this._changeCart(instruction.desiredCartId, true, false, instruction);
    } else if (lastUnfinishedCartID !== -1) {
      setForceCart(lastUnfinishedCartID);
    }

    this.props.forceCart(forceCart);
    this.setState(
      {
        operatorID,
        removeSkuAccess,
        cancelSortBoxAccess,
        nextAction,
      },
      () => {
        //fix for timing issues with setconveyorID
        setTimeout(() => {
          callback();
        }, 250);
      }
    );
  }

  _checkPreviousSort() {
    const logoutTime = this.state.logoutTime;

    const date = new Date();
    const currentTime = date.getTime();
    const persistedCartID = this.props.persistedState.cartID;

    const sortExpirationTime = Constants.SORT_EXPIRATION_TIME_MS;

    if (currentTime > logoutTime + sortExpirationTime || persistedCartID === -1) {
      this.props.persistedCartID(-1);
      this.props.persistedSortID(-1);
      this.setState({
        logoutTime: null,
      });
      return -1;
    } else {
      this.setState({
        logoutTime: null,
        nextAction: ActionTypes.SET_CART,
      });
      return persistedCartID;
    }
  }

  _getIPackBoxIDAtWorkstation() {
    this.setState(
      {
        waitingForNewIPackBox: true,
        nextAction:
          this.props.cartState.isSingleCart || this._getIsVagnSingleMode()
            ? ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN
            : ActionTypes.GET_SHELF,
      },
      this._performNextAction
    );
  }

  _getIsVagnSingleMode() {
    return (
      this.state.singleItems?.some((x) => !x.isLocked && x.packable) === true &&
      this.state.currentShelfNumber === 51
    );
  }

  _validateFinalizeState(state, isPartialDelivery, currentSortBoxID) {
    if (state.finalizeEmpty) return;
    if (state.boxItems.length === 0) {
      throw new Error("Fel vid utleverans, artiklar saknas");
    }
    if (state.boxItems.every((x) => x.verifiedQuantity === 0)) {
      throw new Error("Fel vid utleverans, inga artiklar är skannade");
    }
    if (state.boxItems.some((x) => x.verifiedQuantity < (x.reservedQuantity - x.missingQuantity) && (x.skuID < Constants.RX_BAG_SKU || !this.props.aframeReviewState.rxFloorVisited )) && !isPartialDelivery ) {
      throw new Error("Fel vid utleverans, alla artiklar är inte skannade");
    }
    if (state.boxItems.some((x) => x.boxID !== currentSortBoxID)) {
      //throw new Error("Lådans innehåll är felaktigt");
    }
  }

  _instructParkLocation(parkPlace) {
    this._showWarningModal(
      `Parkera vagnen på plats ${parkPlace.location}${parkPlace.position}`,
      REPARK_CART_INSTRUCTION,
      "Hänvisning",
      "warning-modal-instruction",
      false,
      false
    );
  }

  _finalizeBox(iPackBoxBarcode, scannedItems) {
    let { finalizePending, scanIDs, singleItems, currentSortBoxID, isPartialDelivery } = this.state;

    const aFrameControl = this.props.appState.appMode === ApplicationMode.AFrameReviewMode;
    const boxReviewMode = this.props.appState.appMode === ApplicationMode.BoxReviewMode
    if (aFrameControl) {
      iPackBoxBarcode = this.props.aframeReviewState.iPackBoxBarcode;
    }

    const workstationType = this.props.loginState.workstationType;
    const isAutoPack = UtilMethods.IsAutoPack(workstationType);

    if (!finalizePending) {
      this.setState(
        {
          finalizePending: true,
          waitingForNewIPackBox: isAutoPack,
          waitingForEjectReport: isAutoPack,
        },
        () => {
          this.props.toggleLoading(true);
          try {
            this._validateFinalizeState(this.state, isPartialDelivery, currentSortBoxID);
          } catch (e) {
            this.props.toggleLoading(false);
            return this.setState({
              finalizePending: false,
              isPartialDelivery: false,
              failedToDeliver: true,
              failedToDeliverMessage: e.message,
              failedToDeliverErrorCode: VALIDATE_FINALIZE_STATE_ERROR_CODE,
            });
          }
          //nedan skall aldrig kunna inträffa! //Senad
          if (currentSortBoxID == -1) ClientEventEndpoints.logClientError("FinalizeSortbox får currentSortBoxID=-1, loggar nuvarande state: " + JSON.stringify(this.state));

          SortBoxEndpoints.finalizeSortbox(
            currentSortBoxID,
            iPackBoxBarcode,
            scanIDs,
            isPartialDelivery,
            scannedItems,
            aFrameControl,
            this.props.aframeAppState.aFrameControlStationType
          )
            .then((result) => {
              if (this.state.finalizeEmpty) {
                this.setState({
                  finalizeEmpty: false,
                });
              }
              if (singleItems && singleItems.length && (!isPartialDelivery || this._allItemsVerified())) {
                this._reloadSingels(this.props.cartState.currentCart, currentSortBoxID);
              }
              if (result && result.reparkTarget && result.reparkTarget.location > 0) {
                this._instructParkLocation(result.reparkTarget);
              }
              if (UtilMethods.IsAutoPack(this.props.loginState.workstationType)) {
                if (result.iPackBoxBarcode) {
                  SortBoxEndpoints.sendSuccesfullDeliveryIPackEjector(result.iPackBoxBarcode)
                    .then(() => {
                      this._waitForEjectReport(result);
                    })
                    .catch((e) => {
                      if (e) ClientEventEndpoints.logClientError("sendSuccesfullDeliveryIPackEjector får exception: " + JSON.stringify(e));
                      this._onErrorFinalizeSortbox(result, EJECT_REMOVE_BOX_ERROR_MESSAGE);
                    });
                }
                else if (this.state.isPartialDelivery && this._allItemsVerified() && !this._someItemsVerified()) {
                  this._nextSortBoxTrigger();
                } else {
                  this._onErrorFinalizeSortbox(result, Constants.GeneralErrorMessage);
                }
              } else {
                if (this.state.isPartialDelivery && !this._allItemsVerified() && !isAutoPack) {
                  if (boxReviewMode) {
                    this.props.reloadBoxReview(true);
                    this.props.setBoxReviewModelItems(result.items);
                  }
                  this.setState({
                    boxItems: result.items,
                    finalizePending: false,
                    partialDeliveryStarted: true,
                    partialDeliveryContinued: false
                  });
                  this.props.toggleLoading(false);

                  if (result.shippingLabelVerificationRequired) {
                    this._validateShippingLabel(result.packageNumber, result.order);
                  } else if (result.shippingContainerVerificationRequired) {
                    this._validateShippingContainer(result.packageNumber);
                  } else {
                    this._performNextAction();
                  }
                } else {
                  if (result.shippingLabelVerificationRequired) {
                    this._validateShippingLabel(result.packageNumber, result.order);
                  } else if (result.shippingContainerVerificationRequired) {
                    this._validateShippingContainer(result.packageNumber);
                  } else {
                    this._nextSortBoxTrigger();
                  }
                }
              }
            })
            .catch((e) => {
              this.props.toggleLoading(false);
              if (e) ClientEventEndpoints.logClientError("finalizeSortbox får exception: " + JSON.stringify(e));
              const errorMessage = e.exceptionMessage ?? "Något gick fel vid utleverans.";
              this.setState({
                finalizePending: false,
                isPartialDelivery: false,
                failedToDeliver: true,
                finalizeEmpty: false,
                failedToDeliverMessage: errorMessage,
                failedToDeliverErrorCode: FINALIZE_SORTBOX_ERROR_CODE,
              });
              console.log(e);
            })
            .finally(this._clearUpdateLockExpiration);
          this._getPackagingType();
        }
      );
    }
  }

  _onErrorFinalizeSortbox(result, errorMessage) {
    this.props.toggleLoading(false);
    const finalizeSortModalOpen = result.sortIsDone && !this.props.cartState.isSingleCart;
    this.setState(
      {
        finalizePending: false,
        waitingForEjectReport: false,
        finalizeSortModalOpen,
        wasCancelled: false,
      },
      () => {
        this._showWarningModal(
          errorMessage,
          ON_ERROR_FINALIZE_SORTBOX_ERROR_CODE,
          "Något gick fel"
        );
      }
    );
  }

  _resetPartialQuantity() {
    let boxItems = this.state.boxItems;
    boxItems.forEach((box) => {
      box.partialQuantity = 0;
    });
    this.setState({
      boxItems,
      waitingForDeliveryRequest: false,
      iPackBoxBarcode: null,
    });
  }

  _waitForEjectReport(requestResult) {
    requestResult = requestResult || {};

    let timeout = setTimeout(() => {
      ClientEventEndpoints.logClientError("_waitForEjectReport får timeout för requestResult:" + JSON.stringify(requestResult));
      this._onErrorFinalizeSortbox(requestResult, EJECT_ERROR_MESSAGE);
    }, 6000);
    let interval = setInterval(() => {
      if (!this.state.waitingForEjectReport) {
        clearTimeout(timeout);
        clearInterval(interval);
        if (!this._allItemsVerified() &&
          this.props.cartState.sortType !== SortType.AFRAMEMIXEDSINGLE &&
            this.props.cartState.sortType !== SortType.AFRAMEMIXEDNORMAL) {
          this.setState({
            boxItems: requestResult.items,
            finalizePending: false,
            waitingForDeliveryRequest: false,
            partialDeliveryStarted: true,
            partialDeliveryContinued: false
          });
          this.props.toggleLoading(false);
        } else if (!requestResult.sortIsDone || this.props.cartState.isSingleCart) {
          this._nextSortBoxTrigger();
        } else {
          this.setState({
            finalizeSortModalOpen: true,
            finalizePending: false,
          });
          this.props.wasCancelled(false);
          this.props.toggleLoading(false);
        }
      }
    }, 500);
  }
  _validateShippingLabel(packageNumber, validateOrderInfo) {
    this.setState({
      verifyShippingLabelOpen: true,
      packageNumber: packageNumber,
      validateOrderInfo,
    });
  }
  _completeValidateShippingLabelCallback() {
    this.setState({
      verifyShippingLabelOpen: false,
      packageNumber: null,
      validateOrderInfo: null,
    });

    if (!this._allItemsVerified()) {
      this._performNextAction();
    } else {
      this._nextSortBoxTrigger();
    }
  }

  _validateShippingContainer(packageNumber) {
    this.setState({
      verifyShippingContainerOpen: true,
      packageNumber: packageNumber,
    });
  }

  _validateShippingContainterCallback() {
    this.setState({
      verifyShippingContainerOpen: false,
      packageNumber: null,
    });

    if (!this._allItemsVerified()) {
      this._performNextAction();
    } else {
      this._nextSortBoxTrigger();
    }
  }
  async _nextSortBoxTrigger() {
    if (this.props.appState.appMode === ApplicationMode.BoxReviewMode){
      this.props.clearBoxReviewState();
      this._boxReviewClearState();      
      this.props.toggleLoading(false);
      return
    }

    let nextAction = UtilMethods.IsAutoPack(this.props.loginState.workstationType)
      ? ActionTypes.INITIALIZE_BOX_CHECK
      : (UtilMethods.IsManualPack(this.props.loginState.workstationType) &&
        this.props.cartState.isSingleCart) ||
        this._getIsVagnSingleMode()
        ? ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN
        : ActionTypes.GET_SHELF;

    this.props.toggleLoading(false);
    const boxItems =
      this.props.appState.appMode === ApplicationMode.AFrameReviewMode ? this.state.boxItems : [];
    this.setState(
      {
        currentSortBoxID: -1,
        currentOrderNumber: -1,
        currentShelfNumber: -1,
        boxItems: boxItems,
        nextAction: nextAction,
        waitingForDeliveryRequest: false,
        finalizePending: false,
        finalizeSortModalOpen: false,
        verifyShippingLabelOpen: false,
        validateOrderInfo: null,
      },
      () => {
        if (this.props.appState.appMode === ApplicationMode.PackingMode) {
          this._performNextAction();
        } else if (this.props.appState.appMode === ApplicationMode.AFrameReviewMode) {
          this._verifyAFrameOrderBox();
        }
      }
    );
  }

  _forceNormalWorkstationShelf(
    isPaused,
    approvedBy,
    successCallback = null,
    failureCallback = null
  ) {
    this._cancelSortBox(isPaused, approvedBy, successCallback, failureCallback);
  }
  _setWeightOnSku(skuID, weight) {
    return SkuEndpoints.setWeightOnSku(skuID, weight).then((x) => {
      this._updateBoxItemsState(skuID);
    });
  }

  _updateBoxItemsState(skuID) {
    var updateBoxitems = [...this.state.boxItems];
    updateBoxitems.forEach((bi) => {
      if (bi.skuID === skuID) {
        bi.requireWeighing = false;
      }
    });
    this.setState(
      {
        boxItems: updateBoxitems,
      },
      () => {
        this._setInputFocus();
      }
    );
  }

  _setCartSuggestion = (instruction) => {
    this.props.setCartSuggestion(instruction.desiredCartId);
    this.setState({
      warningHeader: "Hänvisning",
      warningMessage: instruction.message,
      nextAction: ActionTypes.SET_CART,
      pendingInstruction: "",
    });
  };

  _startSingelSort() {
    CartEndpoints.getSingleCart().then((cartnumber) => {
      var completionCallback = () => {
        this._clearCartState();
        this.props.clearCartState();
        this.props.setCartSuggestion(-1);
        this.props.wasCancelled(false);
        this.props.setCartType(Constants.CartType.SINGEL_CART);
        this.setState(
          {
            waitingForDeliveryRequest: false,
            nextAction: ActionTypes.SET_CART,
            forceShelf: null,
            cartContent: null,
          },
          () => this._performNextAction(cartnumber + "", Constants.SCAN_INPUT_TYPE_CART)
        );
      };
      this.props.toggleLoading(false);
      this._clearUpdateLockExpiration();
      OperatorEndpoints.clearPendingInstructions()
        .then(completionCallback)
        .catch(completionCallback);
    });
  }

  _getWeightSku(skuID) {
    return SkuEndpoints.getWeightSku(skuID);
  }

  _cancelSortBox(isPaused, approvedBy, successCallback = null, failureCallback = null) {
    this.props.showLoader(true);
    let nextAction;
    if (this.state.boxLookupApplicationMode) {
      nextAction = ActionTypes.SET_CART;

      this._clearCartState();

      // Grr! this should not be included in _clearCartState
      delete this.state.boxLookupApplicationMode;
    } else {
      // Proceed as it had been doing so up until now.
      nextAction = this.props.cartState.isSingleCart
        ? ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN
        : ActionTypes.GET_SHELF;
    }

    IPackEndpoints.cancelSortBox(
      this.state.currentSortBoxID,
      [],
      isPaused,
      approvedBy,
      false,
      this.props.appState.isScanIdValidationCancelSortboxRequired
    )
      .then((res) => {
        this.props.wasCancelled(false);
        successCallback && successCallback();
        this.setState(
          {
            boxItems: [],
            waitingForDeliveryRequest: false,
            nextAction: nextAction,
            isPaused: isPaused,
            forceShelf: null,
          },
          this._performNextAction
        );

        if (
          !this.state.boxLookupApplicationMode &&
          res &&
          res.shouldRepark &&
          res.parkPlace &&
          res.parkPlace.location > -1
        ) {
          this._instructParkLocation(res.parkPlace);
        }
      })
      .catch((error) => {
        !failureCallback &&
          this._showWarningModal(
            error.message,
            CANCEL_SORTBOX_ERROR_CODE,
            "Lyckades inte avbryta fack"
          );
        failureCallback && failureCallback(error);
        console.error(error);
      })
      .finally(() => {
        this.props.showLoader(false);
      });
  }

  _logState() {
    //console.log("this.state: ", this.state);
  }

  _loadSingleItems(cartNumber, currentSortBoxID) {
    this.setState({
      isLoadingSingleItems: true,
    });

    const _mergeSingleItems = (sItems) => {
      return SharedFunctions.mergeItems("boxID", sItems);
    };

    return SinglesEndpoints.loadSingleItems(cartNumber)
      .then((singleItems) => {
        if (singleItems && singleItems.length) {
          singleItems = _mergeSingleItems(singleItems);
        }

        this.setState({
          singleItems: singleItems,
          isLoadingSingleItems: false,
        });
        this._refreshSingleItemsGrid(currentSortBoxID);
      })
      .catch(() => {
        this.setState({
          isLoadingSingleItems: false,
        });
      });
  }

  async _failureToDeliverCallback() {
    if (this.props.appState.appMode == ApplicationMode.PackingMode || this.props.appState.appMode === ApplicationMode.BoxReviewMode)  {
      var isFailure = true;
      IPackEndpoints.cancelSortBox(
        this.state.currentSortBoxID,
        [],
        false,
        null,
        isFailure,
        this.props.appState.isScanIdValidationCancelSortboxRequired
      )
        .then(() => {
          this.props.toggleLoading(true);
          this.setState(
            {
              failedToDeliver: false,
              failedToDeliverMessage: null,
              failedToDeliverErrorCode: null,
              nextAction:
                this._getIsVagnSingleMode() ||
                  UtilMethods.IsManualPack(this.props.loginState.workstationType)
                  ? ActionTypes.WAITING_FOR_SINGLE_ARTICLE_SCAN
                  : this.state.nextAction,
              waitingForEjectReport: false,
              finalizePending: false,
              forceShelf: null,
            },
            () => {
              if (this.props.appState.appMode === ApplicationMode.BoxReviewMode){
                this.props.reloadBoxReview(true);
                this.props.setBoxReviewAction(BoxReviewActionStates.LOAD_BOX);  
                this.props.toggleLoading(false);
              } else {
                this._nextSortBoxTrigger();
                this._setInputFocus();
              }
            }
          );
        })
        .catch((error) => {
          this._showWarningModal(error.message, FAILURE_TO_DELIVER_CANCEL_SORTBOX_ERROR_CODE);
          console.error(error);
          this.props.toggleLoading(false);
          this._setInputFocus();
        });
    }
    else  {
      this._completeAFrameOrder();
    }
  }

  async _failureToDeliverAFrameMixedCallback() {
    if (this.props.appState.appMode === ApplicationMode.PackingMode || this.props.appState.appMode === ApplicationMode.BoxReviewMode) {

      this.props.toggleLoading(true);
      this.setState(
        {
          failedToDeliver: false,
          failedToDeliverMessage: null,
          failedToDeliverErrorCode: null,
          nextAction: this.state.nextAction,
          waitingForEjectReport: false,
          finalizePending: false,
          forceShelf: null,
        },
        () => {
          if (this.props.appState.appMode === ApplicationMode.BoxReviewMode){
            this.props.reloadBoxReview(true);
            this.props.setBoxReviewAction(BoxReviewActionStates.LOAD_BOX);  
            this.props.toggleLoading(false);
          }
          else {
            this._nextSortBoxTrigger();
            this._setInputFocus();
          }
        }
      );
    } 
    
    else {
      this._completeAFrameOrder();
    }
  }

  getWeightForBox(items) {
    return items
      .map(
        (value) =>
          value.articleWeight *
          (value.reservedQuantity - value.verifiedQuantity + value.partialQuantity)
      )
      .reduce(function (a, b) {
        return a + b;
      }, 0);
  }

  _showModalPackBurnedDeadlineOrdersFirst() {
    this.props.clearCartState();
    this._clearCartState();
    this.props.setCartSuggestion(-1);
    this.props.wasCancelled(false);
    this.setState({
      waitingForDeliveryRequest: false,
      nextAction: ActionTypes.SET_CART,
      forceShelf: null,
      cartContent: null,
      isCartInstruction: true,
    });
    let warningHeader = "Hänvisning";
    let warningClass = "warning-modal-instruction";
    this._showWarningModal(
      "Denna vagn har inga tillgänliga ordrar att packa, välj en annan vagn med brända prio-ordrar",
      SHOW_WORKSTATION_NO_INSTRUCTION_ERROR_CODE,
      warningHeader,
      warningClass,
      false,
      false,
      null
    );
  }
  getScannedWeight(items) {
    return items
      .map((value) => value.articleWeight * value.partialQuantity)
      .reduce(function (a, b) {
        return a + b;
      }, 0);
  }

  getCurrentShipping(currentBoxID, boxItems) {
    var box = currentBoxID;
    var shippingMethod = 0;
    var itemName = boxItems.map((bi) => bi.name)[0];
    if (
      this.props.cartState.sortType === SortType.SINGEL ||
      this.props.cartState.sortType === SortType.AFRAMEMIXEDSINGLE ||
      this._getIsVagnSingleMode()
    ) {
      this.state.singleItems.forEach((item) => {
        if (item.name === itemName) {
          shippingMethod = item.shippingMethodId;
        }
      });
    } else if (this.props.appState.appMode === ApplicationMode.BoxReviewMode) {
      shippingMethod = this.state.reviewBoxShippingMethod;
    } else if (this.props.appState.appMode === ApplicationMode.AFrameReviewMode) {
      return this.props.aframeReviewState.shippingMethod;
    } else {
      this.state.cartContent.cartItems.forEach((item) => {
        //console.log('current boxid: ' + box);
        if (item.boxID === box) {
          //console.log(item.shippingMethodID);
          shippingMethod = item.shippingMethodID;
        }
      });
    }
    return shippingMethod;
  }

  _checkModalStatus() {
    const missingBoxItem = !!this.state.missingBoxItem;
    const {
      verifyShippingContainerOpen,
      verifyShippingLabelOpen,
      finalizeSortModalOpen,
      warningModalOpen,
      failedToDeliver,
      partialDeliveryConfirmationModalOpen,
      showBoxErrorModal,
      showRxOrder,
    } = this.state;

    const verifyIPackBoxBarcodeModalOpen = this.props.aframeAppState.verifyIPackBoxBarcodeModalOpen;

    if (
      missingBoxItem ||
      verifyShippingContainerOpen ||
      verifyShippingLabelOpen ||
      finalizeSortModalOpen ||
      warningModalOpen ||
      failedToDeliver ||
      partialDeliveryConfirmationModalOpen ||
      showBoxErrorModal ||
      showRxOrder ||
      verifyIPackBoxBarcodeModalOpen
    ) {
      return true;
    }
    return false;
  }

  _measurementCallback = (skuID) => {
    if (skuID && skuID !== -1) {
      this._updateBoxItemsState(skuID);
    }
    const { workstationType } = this.props.loginState;

    const isAuto = UtilMethods.IsAutoPack(workstationType);

    if (this.state.waitingforMeasurement && isAuto) {
      this.setState({
        waitingForDeliveryRequest: true,
      });
    } else if (this.state.waitingforMeasurement) {
      this._finalizeBox();
      this.setState({ waitingforMeasurement: false });
    }
  };

  _boxReviewClearState = () => {
    StatePersistor.clearPersistedState(persistedStateConfig.persistorPrefix);
    this.props.clearCartState();
    this._clearCartState();
  }

  _getAppModeSettings = () => { };

  _setScannedBoxManually(input){
    let trimmedBoxBarcode = input.replace(/^B+/,'');
    IPackEndpoints.setBoxManually(trimmedBoxBarcode);
  }

  render() {
    let classes = classNames({
      MainApp: true,
    });
    const { appMode } = this.props.appState;
    const partialDeliveryAllowed = this.state.partialDeliveryAllowed;

    // Gula först, sen vita, sen gröna
    let boxItems = (appMode !== ApplicationMode.AFrameReviewMode ? this._getMergedBoxItems() :this.state.boxItems) .sort(function (a, b) {
      let a_status =
        a.reservedQuantity === a.verifiedQuantity ? 1 : a.verifiedQuantity > 0 ? -1 : 0;
      let b_status =
        b.reservedQuantity === b.verifiedQuantity ? 1 : b.verifiedQuantity > 0 ? -1 : 0;

      return a_status < b_status ? -1 : a_status > b_status ? 1 : 0;
    });

    let operatorInstruction = <>{this._getOperatorInstruction()}</>;

    if (this.props.loginState.operatorID === -1) {
      return (
        <React.Fragment>
          <Login
            loginCallback={this._setOperator}
            workstationID={this.props.loginState.workstationID}
          />
          {/* <ErrorAlert error={this.props.appState.errorMessage} /> */}
        </React.Fragment>
      );
    }

    const { operatorID, operatorName, workstationType } = this.props.loginState;

    let displayingModal = this._checkModalStatus();
    let showPrintbutton =
      this.state.boxItems.some((box) => box.partialQuantity > 0) || this.props.appState.loading;
    let iPackWarningLampVisible =
      UtilMethods.IsAutoPack(workstationType) && this.state.waitingForNewIPackBox;
    let hasPackableSingles = this._getIsVagnSingleMode();
    let singleWaiting =
      (this.props.cartState.isSingleCart || hasPackableSingles) &&
      (this.state.waitingForEjectReport || this.state.finalizePending);
    let inputDisabled =
      this.state.scanDisabled || singleWaiting || displayingModal || this.state.sideMenuOpen;
    let isApoteaPackaging = this.state.packagingType === Constants.PackagingTypes.Apotea;
    let showCancelButton =
      this.state.currentSortBoxID > 0 &&
      this.state.currentShelfNumber > 0 &&
      UtilMethods.IsAutoPack(workstationType) &&
      appMode !== ApplicationMode.BoxReviewMode;
    let cartLoaded =
      this.state.cartContent !== null &&
      this.state.cartContent.cartItems.length > 0 &&
      this.props.cartState.currentCart !== -1;

    let hasPackableSortboxes =
      this.state.cartContent?.cartItems?.some((x) => !x.isLocked && x.packable) === true;
    let skipBurnedDeadlinesPriority =
      this.props.cartState.isRXSingle ||
      appMode === ApplicationMode.BoxReviewMode;
    if (
      this.props.appState.burnedOrdersMustBePackedFirst &&
      !hasPackableSortboxes &&
      !skipBurnedDeadlinesPriority &&
      this.state.warningModalOpen === false &&
      this.state.nextAction !== ActionTypes.GET_SHELF &&
      !hasPackableSingles &&
      cartLoaded &&
      this.props.cartState.cartSuggestion === -1
    ) {
      //inga tillgänliga ordrar på vagnen, visa meddelande om att brända prio-ordrar måste packas försts
      //this._showModalPackBurnedDeadlineOrdersFirst();
    }

    const isAFrameMixedSortType = isAFrameMixed(this.props.cartState.sortType);
    const isManualStation = UtilMethods.IsManualPack(workstationType);
    const { boxReviewAction } = this.props.boxReviewState;

    const isAutoPack = UtilMethods.IsAutoPack(workstationType)

    return (
      <div className={classes}>
        <Dimmer active={this.props.appState.loading} inverted>
          <Loader size="big" />
        </Dimmer>

        <SideBarMenu
          clearPersistedState={() => StatePersistor.clearPersistedState(persistedStateConfig.persistorPrefix)}
          clearCartState={() => this.props.clearCartState()}
          partialDelivery={
            appMode !== ApplicationMode.AFrameReviewMode &&
              this._hasBox() &&
              partialDeliveryAllowed &&
              !this.state.isPartialDelivery &&
              isManualStation
              ? () => this.setState({ partialDeliveryConfirmationModalOpen: true })
              : null
          }
          logOut={
            appMode !== ApplicationMode.AFrameReviewMode ? this._signOut : null
          }
          changeCart={
            appMode === ApplicationMode.PackingMode || (appMode === ApplicationMode.BoxReviewMode && boxReviewAction === BoxReviewActionStates.PACK_MODE)
              ? () => this._changeCart(-1, false, false)
              : null
          }
          startSingel={
            (appMode === ApplicationMode.PackingMode || 
              (appMode === ApplicationMode.BoxReviewMode && boxReviewAction === BoxReviewActionStates.PACK_MODE)) &&
              this.props.cartState.rxEnabled
              ? this._startSingelSort
              : null
          }
          scanNewOrder={
           appMode === ApplicationMode.AFrameReviewMode
              ? this.completeAFrameOrderProp
              : null
          }
          menuOpen={() => this.setState({ sideMenuOpen: true })}
          menuClose={() => this.setState({ sideMenuOpen: false }, this._setInputFocus)}
        />

        <Grid columns={2} className="GridContainer">
          <Grid.Column className="articleColumn" width={10}>
            <BoxItemList
              allSortBoxItems={appMode === ApplicationMode.AFrameReviewMode ? this.props.aframeReviewState.allSortBoxItems : boxItems}
              skuChannels={this.props.aframeReviewState.channelItems}
              dynamicSkuChannels={this.props.aframeReviewState.dynamicChannelItems}
              skuIsMissingCallback={this._skuIsMissing}
              boxItems={boxItems}
              isLoading={this.props.appState.loading}
              skuInputCallback={this._handleArticleScan}
              isSingle={this.props.cartState.isSingleCart}
              isWaitingForBox={this.state.waitingForNewIPackBox}
              aframe={appMode === ApplicationMode.AFrameReviewMode}
              isPaused={this.state.isPaused}
              isAuto={UtilMethods.IsAutoPack(workstationType)}
              isUrgent={this.state.isUrgent}
              currentCart={this.props.cartState.currentCart}
              alwaysShowMissing={appMode === ApplicationMode.AFrameReviewMode && this.props.aframeReviewState.orderStatus === "Kontrollerad"}
            />
            <IPackBoxStatus visible={iPackWarningLampVisible} size={"huge"} />
          </Grid.Column>
          <Grid.Column width={6}>
            <Grid columns={2}>
              <Grid.Column className="noPaddingRight" width={4}>
                {appMode === ApplicationMode.PackingMode ? (
                  <CollectingAverage
                    show={
                      this.props.cartState.currentCart !== -1 && !this.props.cartState.isRXSingle
                    }
                    operatorID={this.props.loginState.operatorID}
                  />
                ) : null}
              </Grid.Column>
              <Grid.Column className="noPaddingLeft flexColumn dontExtend" width={12}>
                <InfoBar
                  fromReview={appMode !== ApplicationMode.PackingMode}
                  latestShipping={
                    appMode === ApplicationMode.AFrameReviewMode
                      ? this.props.aframeReviewState.latestShipping
                      : null
                  }
                  noPackMessage={
                    this.props.cartState.isRXSingle ||
                    appMode === ApplicationMode.BoxReviewMode ||
                    this.props.cartState.sortType === SortType.SINGEL ||
                    this.props.cartState.sortType === SortType.AFRAMEMIXEDSINGLE ||
                    this._getIsVagnSingleMode()
                  }
                  allVerified={this._allItemsVerified()}
                  currentCart={this.props.cartState.currentCart}
                  isAuto={isAutoPack}
                  nextAction={this.state.nextAction}
                  shelfCallback={this._forceNormalWorkstationShelf}
                  cancelSortBoxAccess={this.state.cancelSortBoxAccess}
                  showCancelButton={showCancelButton &&  isAutoPack}
                  waitingForDeliveryRequest={this.state.waitingForDeliveryRequest}
                  waitingForNewIPackBox={this.state.waitingForNewIPackBox}
                  operatorInstruction={operatorInstruction}
                  operator={operatorName}
                  operatorID={operatorID}
                  isPartialDelivery={this.state.isPartialDelivery && appMode !== ApplicationMode.AFrameReviewMode}
                  wasCancelled={this.props.appState.wasCancelled}
                  cartContent={this.state.cartContent}
                  currentOrderNumber={this.state.currentOrderNumber}
                  currentSortBoxID={this.state.currentSortBoxID}
                  currentShelf={this.state.currentShelf}
                  cartType={this.props.cartState.cartType}
                  shippingMethod={
                    cartLoaded
                      ? this.getCurrentShipping(this.state.currentSortBoxID, this.state.boxItems)
                      : null
                  }
                  weight={cartLoaded || appMode === ApplicationMode.BoxReviewMode ? this.getWeightForBox(this.state.boxItems) : 0}
                  scannedWeight={cartLoaded ? this.getScannedWeight(this.state.boxItems) : 0}
                  fromAFrameControl={
                    appMode === ApplicationMode.AFrameReviewMode
                  }
                  aFrameCompletionMode={
                    appMode === ApplicationMode.AFrameReviewMode &&
                    this.props.aframeAppState.aFrameAction === ActionStates.COMPLETE_BOX
                  }
                  isPaused={this.state.isPaused}
                  isSingle={this.props.cartState.isSingleCart}
                  sortType={this.props.cartState.sortType}
                  workstationType={workstationType}
                  sortWorkstationType={
                    this.props.cartState.sortType === SortType.AFRAMEMIXEDSINGLE
                      ? this.props.cartState.workstationType
                      : this.state.sortWorkstationType
                  }
                  isScanIdValidationCancelSortboxRequired={
                    this.props.appState.isScanIdValidationCancelSortboxRequired
                  }
                  aFrameControlStation={this.props.aframeAppState.aFrameControlStationVisibleType}
                  boxWeightModel={this.props.aframeReviewState.sortBoxModel?.boxWeightModel}
                  orderStatus={this.props.aframeReviewState.orderStatus}
                  companyID={this.props.loginState.companyID}
                ></InfoBar>
                {appMode === ApplicationMode.AFrameReviewMode ? (
                  <WarningList
                    infoBarHeight={this.props.layout.height}
                    hasWarnings={this.props.aframeReviewState.hasWarnings}
                    warnings={this.props.aframeReviewState.warnings}
                    boxID={this.state.currentSortBoxID}
                    orderCompletition={true}
                  ></WarningList>
                ) : this.props.cartState.isRXSingle ? null : this.props
                    .cartState.sortType === SortType.SINGEL ||
                    this.props.cartState.sortType === SortType.AFRAMEMIXEDSINGLE ||
                    hasPackableSingles ? (
                  <SingleItemList
                    infoBarHeight={this.props.layout.height}
                    showCancelButton={showCancelButton}
                    crateId={this.props.cartState.currentCart}
                    boxItems={this.state.singleItems}
                    cartItems={this.state.cartContent?.cartItems}
                    getNextSortBoxCallback={this._getNextSortBox}
                    skuIsMissingCallback={this._skuIsMissing}
                    isLoading={this.state.isLoadingSingleItems}
                    currentSortBoxID={this.state.currentSortBoxID}
                    refreshCallback={() => {
                      this._loadSingleItems(
                        this.props.cartState.currentCart,
                        this.state.currentSortBoxID
                      );
                    }}
                    manualSkuCallback={this._handleSingelArticleScan}
                    missingCallback={this._skuIsMissing}
                    currentCart={this.props.cartState.currentCart}
                  />
                ) : (
                  <CartContent
                    infoBarHeight={this.props.layout.height}
                    showCancelButton={showCancelButton}
                    cartType={this.props.cartState.cartType}
                    cartContent={this.state.cartContent}
                    getSortBox={this.state.partialDeliveryStarted && !this.state.partialDeliveryContinued ? null : this._getNextSortBox}
                    currentShelf={this.state.currentShelfNumber}
                    currentBoxID={this.state.currentSortBoxID}
                    currentCart={this.props.cartState.currentCart}
                    handleSingleShelf={this._setStateWaitingForSingleArticleScan}
                  />
                )}
              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid>
        {this.state.verifyShippingContainerOpen ? (
          <ScanShippingContainerModal
            open={this.state.verifyShippingContainerOpen}
            companyID={this.state.sortBoxCompanyID}
            workstationID={this.props.loginState.workstationID}
            onClose={this._validateShippingContainterCallback}
            packageNumber={this.state.packageNumber}
          ></ScanShippingContainerModal>
        ) : null}
        {this.state.verifyShippingLabelOpen ? (
          <ScanShippingLabelModal
            open={this.state.verifyShippingLabelOpen}
            onClose={this._completeValidateShippingLabelCallback}
            packageNumber={this.state.packageNumber}
            orderInfo={this.state.validateOrderInfo}
          />
        ) : null}
        {this.state.finalizeSortModalOpen ? (
          <FinalizeSortModal
            open={this.state.finalizeSortModalOpen}
            sortID={this.props.cartState.sortID}
            articleScan={this._handleSingelArticleScan}
            onClose={this._closeFinalizeSortModal}
            iPackWarningLampVisible={iPackWarningLampVisible}
            isLoading={this.props.appState.loading}
          />
        ) : null}
        {this.props.aframeAppState.warningMessage ? (
          <WarningModal
            open={true}
            cssClass={"warning-modal-instruction"}
            autoClose={false}
            header="Avbruten"
            message={this.props.aframeAppState.warningMessage}
            onClose={() => this.props.setAframeReviewWarning(null)}
          ></WarningModal>
        ) : null}
        {this.state.warningModalOpen ? (
          <WarningModal
            open={this.state.warningModalOpen}
            onClose={this._getWarningModalOnCloseFunctionByKey(
              this.state.warningOnCloseFunctionKey
            )}
            message={this.state.warningMessage}
            header={this.state.warningHeader}
            cssClass={this.state.warningClass}
            autoClose={this.state.warningAutoClose}
            isCartInstruction={this.state.isCartInstruction}
            workstationID={this.props.loginState.workstationID}
            cartSuggestion={this.props.cartState.cartSuggestion}
            changeCartSuggestion={(instruction) => this._setCartSuggestion(instruction)}
            acceptCart={(cartSuggestion, hasIntruction, triggerNextAction) =>
              this._changeCart(cartSuggestion, hasIntruction, triggerNextAction)
            }
            closeButtonText={this.state.warningButtonText}
            errorCode={this.state.warningErrorCode}
          />
        ) : null}
        {this.state.finalizeEmpty && (
          <FinalizeEmptyAFrameMixedModal
            open={this.state.finalizeEmpty}
            header={"Lådan ska skickas tom"}
          />
        )}
        {!!this.state.missingBoxItem ? (
          <MissingSkuModal
            open={!!this.state.missingBoxItem}
            fromReview={appMode === ApplicationMode.BoxReviewMode}
            removeSkuAccess={this.state.removeSkuAccess}
            currentOrderNumber={this.state.currentOrderNumber}
            boxItem={this.state.missingBoxItem}
            foundSkuCallback={this._updateSortBoxItems}
            onClose={this._dismissMissingSku}
            cartNumber={this.props.cartState.currentCart}
            isScanIdValidationRemoveSkuRequired={
              this.props.appState.isScanIdValidationRemoveSkuRequired
            }
            partialDelivery={this.state.partialDeliveryStarted}
            loginState={this.props.loginState}
          />
        ) : null}
        {this.state.failedToDeliver ? (
          <FailureToDeliverModal
            open={this.state.failedToDeliver}
            onClose={
              isAFrameMixedSortType
                ? this._failureToDeliverAFrameMixedCallback
                : this._failureToDeliverCallback
            }
            isManualPack={isManualStation}
            message={this.state.failedToDeliverMessage}
            errorCode={this.state.failedToDeliverErrorCode}
            isAFrameMixed={isAFrameMixedSortType}
          />
        ) : null}
        {this.state.partialDeliveryConfirmationModalOpen ? (
          <PartialDeliveryConfirmationModal
            open={this.state.partialDeliveryConfirmationModalOpen}
            isManualPack={isManualStation}
            cancelCallback={() => this.setState({ partialDeliveryConfirmationModalOpen: false })}
            continueCallback={() => this._partialDeliveryConfirmationModalCallback(isManualStation)}
          />
        ) : null}
        {this.props.aframeAppState.verifyIPackBoxBarcodeModalOpen ? (
          <AFrameConfirmationModal
            open={this.props.aframeAppState.verifyIPackBoxBarcodeModalOpen}
            callback={this.completeAFrameOrderProp}
            iPackBoxBarcode={this.props.aframeReviewState.iPackBoxBarcode}
          ></AFrameConfirmationModal>
        ) : null}
        {this.state.showBoxErrorModal ? (
          <BoxErrorModal
            open={this.state.showBoxErrorModal}
            header={this.state.boxErrorHeader}
            message={this.state.boxErrorMessage}
            onClose={this._boxRemovedCallback}
          />
        ) : null}
        {this.state.verifyPartialDelivery && (
          <OperatorInputModal
            open={this.state.verifyPartialDelivery}
            submitCallback={(scannedID, successCallback, failureCallback) =>
              this._partialDeliveryAccessCheck(scannedID, successCallback, failureCallback)
            }
            onClose={() => {
              this.setState({
                verifyPartialDelivery: false,
              });
            }}
            submitButtonText="GODKÄNN DELLEVERANS"
            headerText="Börja delleverans"
            isScanIdValidationRequired={true}
          />
        )}
        {this.state.showRxOrder ? (
          <OperatorConfirmModal
            open={this.state.showRxOrder}
            onClose={() =>
              this.setState(
                {
                  showRxOrder: false,
                  boxItems: [...this.state.boxItems].map((item) => {
                    item.verifiedQuantity = 0;
                    return item;
                  }),
                },
                () =>
                  this._showWarningModal(
                    "Skanna varorna igen.",
                    OPERATOR_CONFIRM_MODAL_ERROR_CODE,
                    "Börja om med fack!"
                  )
              )
            }
            SortBoxID={this.state.currentSortBoxID}
            orderNumber={this.state.currentOrderNumber}
            isScanIdValidationRxRequired={this.props.appState.isScanIdValidationRxRequired}
          />
        ) : null}
        <ArticleWeightModal
          scannedSKU={this.state.lastScannedSKU}
          boxItems={this.state.boxItems}
          getWeight={this._getWeightSku}
          setWeight={this._setWeightOnSku}
          autoScaleEnabled={this.props.loginState.autoScaleEnabled}
          cartShelfID={
            this.props.cartState.isSingleCart || this._getIsVagnSingleMode()
              ? ""
              : this.state.currentShelfNumber
          }
          callback={this._measurementCallback}
        />
        <InfoFooter
          currentSortBoxID={this.state.currentSortBoxID}
          cartID={this.props.cartState.currentCart}
          cartShelf={this.state.currentShelfNumber}
          workstationID={this.props.loginState.workstationID}
          operatorName={this.props.loginState.operatorName}
          sortID={this.props.cartState.sortID}
          isApoteaPackaging={isApoteaPackaging}
          companyID={this.state.sortBoxCompanyID}
          pendingInstruction={this.state.pendingInstruction}
          cartLocationHistory={this.props.cartState.locationHistory}
          hasHelpPicklist={this.props.cartState.hasHelpPicklist}
        />
        <NumPad
          className={"ScannerNumPad" + (this.state.showKeyboard ? " slide-in" : "")}
          onClick={this._onKeyPadClick}
        />
        <input
          className="ScanInputField"
          autoComplete="off"
          id="ScanInputField"
          autoFocus
          onKeyPress={(e) => this._onInputKeyPress(e)}
          ref={this.inputRef}
          disabled={inputDisabled}
        />
        <div
          className={"toggle-keyboard" + (this.state.showKeyboard ? "" : " keyboard-hidden")}
          onClick={() => this.setState({ showKeyboard: !this.state.showKeyboard })}
        >
          <Icon name="keyboard outline" />
        </div>
        {this.state.isPartialDelivery && isManualStation && appMode !== ApplicationMode.AFrameReviewMode ? (
          <Button
            className={"PartialDeliveryButton"}
            onClick={this._performPartialDelivery}
            disabled={!showPrintbutton}
          >
            Skriv ut etikett
          </Button>
        ) : null}
        {/* <DevDashBoard
          show={process.env.NODE_ENV === "development"}
          addNewBox={() => this.setState({ waitingForNewIPackBox: false })}
          addNewBoxDisabled={!this.state.waitingForNewIPackBox}
          logState={this._logState}
        /> */}
        <ErrorAlert error={this.props.appState.errorMessage} />
        {isApoteaPackaging ? (
          <img
            className="ApoteaLogo"
            src={process.env.PUBLIC_URL + "/images/apotea.svg"}
            alt="Apoteas Logga"
          ></img>
        ) : (
          <ShopLogo shopID={this.state.orderShopID}></ShopLogo>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cartState: state.cartReducer,
    layout: state.layoutHelperReducer,
    appState: state.applicationStateReducer,
    loginState: state.loginInfoReducer,
    instructionState: state.instructionReducer,
    persistedState: state.persistedStateReducer,
    boxReviewState: state.boxReviewReducer,
    aframeReviewState: state.aFrameReviewBoxReducer,
    aframeAppState: state.aframeModeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLoading: (loading) => dispatch(setLoadingStatus(new PayloadWrapper(loading))),
    showLoader: (show) => dispatch(setShowLoader(show)),
    setUser: (operatorID, operatorName, partialDeliveryAccess, companyID) =>
      dispatch(setUser(new OperatorInfoModel(operatorID, operatorName, partialDeliveryAccess, companyID))),
    setWorkstation: (workstationID, workstationType, branchID, autoScaleEnabled) =>
      dispatch(setWorkstation(new WorkstationInfoModel(workstationID, workstationType, branchID, autoScaleEnabled))),
    setCartSuggestion: (cartSuggestion) =>
      dispatch(setCartSuggestion(new PayloadWrapper(cartSuggestion))),
    setCartID: (payload) => dispatch(setCartID(new PayloadWrapper(payload))),
    scanCartID: (payload, callback) => dispatch(scanCartID(new PayloadWrapper(payload), callback)),
    clearCartState: () => dispatch(clearCartState()),
    setRXEnabled: (value) => dispatch(setRXEnabled(new PayloadWrapper(value))),
    setError: (payload) => dispatch(setError(payload)),
    forceCart: (force) => dispatch(setForceCart(new PayloadWrapper(force))),
    wasCancelled: (cancelled) => dispatch(setWasCancelled(new PayloadWrapper(cancelled))),
    setCurrentInstruction: (instruction, callback) =>
      dispatch(setCurrentInstruction(instruction, callback)),
    clearInstructions: () => dispatch(clearInstructions()),
    toggleShowInstruction: (status) => dispatch(toggleShowInstruction(new PayloadWrapper(status))),
    setLoginStatus: (status) => dispatch(setLoginStatus(new PayloadWrapper(status))),
    setCompanyID: (companyID) => dispatch(setCompanyID(new PayloadWrapper(companyID))),
    persistedSortID: (sortID) => dispatch(setPersistedSortID(new PayloadWrapper(sortID))),
    persistedCartID: (cartID) => dispatch(setPersistedCartID(new PayloadWrapper(cartID))),
    fetchCartData: (setCartCallback, instructionCallback, warningModal) =>
      dispatch(
        fetchCartData({
          setCart: setCartCallback,
          showInstruction: instructionCallback,
          showWarningModal: warningModal,
        })
      ),
    setCartType: (cartType) => dispatch(setCartType(new PayloadWrapper(cartType))),
    setAppMode: (appMode) => dispatch(setAppMode(new PayloadWrapper(appMode))),
    setConveyorID: (conveyorID) => dispatch(setConveyorID(new PayloadWrapper(conveyorID))),
    setSortID: (sortID) => dispatch(setSortID(new PayloadWrapper(sortID))),
    setShouldRedirect: (shouldRedirect) =>
      dispatch(setShouldRedirect(new PayloadWrapper(shouldRedirect))),
    setIsBetaWorkstation: (beta) => dispatch(setIsBetaWorkstation(new PayloadWrapper(beta))),
    setBurnedOrdersMustBePackedFirst: (burnedOrdersMustBePackedFirst) =>
      dispatch(setBurnOrdersMustBeBackedFirst(new PayloadWrapper(burnedOrdersMustBePackedFirst))),
    finishAFrameBox: (clear = false) => {
      dispatch(toggleverifyIPackBoxBarcodeModal(new PayloadWrapper(false)));
      dispatch(setOrderChecked(new PayloadWrapper(true)));
      dispatch(setAFrameAction(new PayloadWrapper(ActionStates.LOAD_BOX)));
      dispatch(setLoadingStatus(new PayloadWrapper(false)));
      dispatch(setMissingBoxItem(new PayloadWrapper(null)));
      if (clear) {
        dispatch(clearReviewBoxData());
      }
    },
    showVerifyIPackBoxBarcodeModal: () => dispatch(toggleverifyIPackBoxBarcodeModal(new PayloadWrapper(true))),
    setPackingAllowed: (packingAllowed) =>
    dispatch(setPackingAllowed(new PayloadWrapper(packingAllowed))),
    reloadBoxReview: (wasUpdated) => dispatch(reloadBoxReview(new PayloadWrapper(wasUpdated))),
    setBoxReviewAction: (action) => dispatch(setBoxReviewAction(new PayloadWrapper(action))),
    clearBoxReviewState: () => dispatch(clearBoxReviewState()),
    setBoxReviewModelItems: (items) => dispatch(setBoxReviewModelItems(items)),
    setAllSortboxItems: (items) => dispatch(setAllSortboxItems(new PayloadWrapper(items))),
    setAframeSortboxItems: (items) => dispatch(setAframeSortboxItems(new PayloadWrapper(items))),
    setAframeReviewWarning: (value) => dispatch(setAframeReviewWarning(new PayloadWrapper(value))),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
